var _defs, _g, _g2, _line, _g3, _g4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse, _path, _path2, _path3, _rect, _rect2, _rect3, _text, _text2, _text3, _polygon, _polyline, _polyline2, _path4, _polyline3, _g5, _path5, _circle10, _path6, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clippath-27);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245, .cls-246, .cls-247, .cls-248, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-291, .cls-292, .cls-293, .cls-294, .cls-295, .cls-296, .cls-297, .cls-298, .cls-299, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-306, .cls-307, .cls-308, .cls-309, .cls-310, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-316, .cls-317, .cls-318, .cls-319, .cls-320, .cls-321, .cls-322, .cls-323, .cls-324, .cls-325, .cls-326, .cls-327, .cls-328, .cls-329 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-330, .cls-9, .cls-331, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-332, .cls-333, .cls-17, .cls-18, .cls-19, .cls-20, .cls-334, .cls-21, .cls-22, .cls-335, .cls-23, .cls-336, .cls-24, .cls-337, .cls-25, .cls-26, .cls-338, .cls-27, .cls-28, .cls-339, .cls-29, .cls-30, .cls-31, .cls-340, .cls-32, .cls-341, .cls-33, .cls-342, .cls-34, .cls-35, .cls-36, .cls-343, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-344, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-345, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-346, .cls-54, .cls-55, .cls-347, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-348, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-349, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-350, .cls-91, .cls-92, .cls-93, .cls-351, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-352, .cls-353, .cls-100, .cls-101, .cls-102, .cls-103, .cls-354, .cls-355, .cls-104, .cls-105, .cls-106, .cls-107, .cls-356, .cls-108, .cls-357, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-358, .cls-114, .cls-115, .cls-359, .cls-116, .cls-117, .cls-118, .cls-119, .cls-360, .cls-120, .cls-121, .cls-361, .cls-122, .cls-362, .cls-123, .cls-363, .cls-364, .cls-365, .cls-124, .cls-366, .cls-125, .cls-367, .cls-368, .cls-126, .cls-369, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-370, .cls-132, .cls-371, .cls-134, .cls-135, .cls-136, .cls-372, .cls-137, .cls-138, .cls-139, .cls-373, .cls-140, .cls-141, .cls-142, .cls-143, .cls-374, .cls-375, .cls-144, .cls-145, .cls-376, .cls-146, .cls-147, .cls-377, .cls-378, .cls-379, .cls-148, .cls-149, .cls-380, .cls-150, .cls-151, .cls-152, .cls-153, .cls-381, .cls-382, .cls-154, .cls-155, .cls-383, .cls-384, .cls-156, .cls-385, .cls-157, .cls-386, .cls-387, .cls-388, .cls-158, .cls-389, .cls-160, .cls-161, .cls-162, .cls-390, .cls-163, .cls-164, .cls-391, .cls-165, .cls-392, .cls-393, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-394, .cls-171, .cls-172, .cls-395, .cls-173, .cls-174, .cls-175, .cls-396, .cls-397, .cls-176, .cls-398, .cls-177, .cls-399, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-400, .cls-186, .cls-187, .cls-188, .cls-189, .cls-401, .cls-190, .cls-402, .cls-191, .cls-192, .cls-403, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-404, .cls-405, .cls-203, .cls-406, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-407, .cls-211, .cls-408, .cls-409, .cls-410, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-411, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-412, .cls-413, .cls-414, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-415, .cls-416, .cls-233, .cls-234, .cls-235, .cls-417, .cls-237, .cls-238, .cls-418, .cls-239, .cls-419, .cls-240, .cls-241, .cls-420, .cls-242, .cls-243, .cls-421, .cls-244, .cls-422, .cls-245, .cls-246, .cls-247, .cls-423, .cls-248, .cls-249, .cls-424, .cls-250, .cls-251, .cls-425, .cls-426, .cls-427, .cls-428, .cls-253, .cls-429, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-430, .cls-266, .cls-267, .cls-431, .cls-268, .cls-269, .cls-270, .cls-271, .cls-432, .cls-433, .cls-272, .cls-434, .cls-435, .cls-273, .cls-436, .cls-274, .cls-275, .cls-276, .cls-437, .cls-277, .cls-438, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-439, .cls-283, .cls-284, .cls-440, .cls-285, .cls-441, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-442, .cls-443, .cls-444, .cls-445, .cls-292, .cls-446, .cls-447, .cls-448, .cls-293, .cls-294, .cls-449, .cls-295, .cls-450, .cls-296, .cls-297, .cls-298, .cls-451, .cls-299, .cls-452, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-453, .cls-306, .cls-307, .cls-454, .cls-308, .cls-309, .cls-310, .cls-455, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-456, .cls-316, .cls-457, .cls-317, .cls-458, .cls-318, .cls-459, .cls-319, .cls-320, .cls-321, .cls-322, .cls-460, .cls-323, .cls-324, .cls-325, .cls-461, .cls-326, .cls-327, .cls-328, .cls-462, .cls-329, .cls-463 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clippath-5655);\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clippath-9366);\r\n      }\r\n\r\n      .cls-464 {\r\n        clip-path: url(#clippath-73);\r\n      }\r\n\r\n      .cls-465 {\r\n        clip-path: url(#clippath-559);\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 7px;\r\n      }\r\n\r\n      .cls-4, .cls-133, .cls-159, .cls-178, .cls-202, .cls-236, .cls-252, .cls-291 {\r\n        stroke: #f7931a;\r\n      }\r\n\r\n      .cls-4, .cls-133, .cls-159, .cls-178, .cls-202, .cls-252, .cls-291 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clippath-10294);\r\n      }\r\n\r\n      .cls-6 {\r\n        clip-path: url(#clippath-4267);\r\n      }\r\n\r\n      .cls-7 {\r\n        clip-path: url(#clippath-10761);\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clippath-14);\r\n      }\r\n\r\n      .cls-330 {\r\n        fill: url(#linear-gradient-38);\r\n      }\r\n\r\n      .cls-9 {\r\n        clip-path: url(#clippath-76);\r\n      }\r\n\r\n      .cls-331 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-10 {\r\n        clip-path: url(#clippath-12);\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clippath-9377);\r\n      }\r\n\r\n      .cls-12 {\r\n        clip-path: url(#clippath-10763);\r\n      }\r\n\r\n      .cls-13 {\r\n        clip-path: url(#clippath-7514);\r\n      }\r\n\r\n      .cls-14 {\r\n        clip-path: url(#clippath-75);\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clippath-7510);\r\n      }\r\n\r\n      .cls-16 {\r\n        clip-path: url(#clippath-2871);\r\n      }\r\n\r\n      .cls-466 {\r\n        clip-path: url(#clippath-11);\r\n      }\r\n\r\n      .cls-332 {\r\n        fill: url(#linear-gradient-127);\r\n      }\r\n\r\n      .cls-333 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-17 {\r\n        clip-path: url(#clippath-6122);\r\n      }\r\n\r\n      .cls-18 {\r\n        clip-path: url(#clippath-9372);\r\n      }\r\n\r\n      .cls-19 {\r\n        clip-path: url(#clippath-6593);\r\n      }\r\n\r\n      .cls-20 {\r\n        clip-path: url(#clippath-1022);\r\n      }\r\n\r\n      .cls-467 {\r\n        clip-path: url(#clippath-59);\r\n      }\r\n\r\n      .cls-334 {\r\n        fill: url(#linear-gradient-88);\r\n      }\r\n\r\n      .cls-21 {\r\n        clip-path: url(#clippath-9369);\r\n      }\r\n\r\n      .cls-468 {\r\n        mask: url(#mask-23);\r\n      }\r\n\r\n      .cls-22 {\r\n        clip-path: url(#clippath-554);\r\n      }\r\n\r\n      .cls-335 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-23 {\r\n        clip-path: url(#clippath-1950);\r\n      }\r\n\r\n      .cls-336 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-24 {\r\n        clip-path: url(#clippath-51);\r\n      }\r\n\r\n      .cls-337 {\r\n        fill: url(#linear-gradient-62);\r\n      }\r\n\r\n      .cls-469 {\r\n        mask: url(#mask-27);\r\n      }\r\n\r\n      .cls-25 {\r\n        clip-path: url(#clippath-94);\r\n      }\r\n\r\n      .cls-26 {\r\n        clip-path: url(#clippath-7977);\r\n      }\r\n\r\n      .cls-470 {\r\n        mask: url(#mask-10);\r\n      }\r\n\r\n      .cls-338 {\r\n        fill: url(#linear-gradient-92);\r\n      }\r\n\r\n      .cls-27 {\r\n        clip-path: url(#clippath-5656);\r\n      }\r\n\r\n      .cls-28 {\r\n        clip-path: url(#clippath-6588);\r\n      }\r\n\r\n      .cls-471 {\r\n        mask: url(#mask-26);\r\n      }\r\n\r\n      .cls-339 {\r\n        fill: url(#linear-gradient-98);\r\n      }\r\n\r\n      .cls-472 {\r\n        clip-path: url(#clippath-47);\r\n      }\r\n\r\n      .cls-29 {\r\n        clip-path: url(#clippath-4265);\r\n      }\r\n\r\n      .cls-30 {\r\n        clip-path: url(#clippath-2881);\r\n      }\r\n\r\n      .cls-31 {\r\n        clip-path: url(#clippath-6129);\r\n      }\r\n\r\n      .cls-340 {\r\n        fill: url(#linear-gradient-67);\r\n      }\r\n\r\n      .cls-32 {\r\n        clip-path: url(#clippath-86);\r\n      }\r\n\r\n      .cls-341 {\r\n        fill: url(#linear-gradient-57);\r\n      }\r\n\r\n      .cls-33 {\r\n        clip-path: url(#clippath-8910);\r\n      }\r\n\r\n      .cls-342 {\r\n        fill: url(#linear-gradient-131);\r\n      }\r\n\r\n      .cls-342, .cls-343, .cls-473, .cls-359, .cls-361, .cls-367, .cls-368, .cls-370, .cls-474, .cls-379, .cls-381, .cls-397, .cls-399, .cls-400, .cls-410, .cls-412, .cls-420, .cls-438 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-342, .cls-343, .cls-410, .cls-420 {\r\n        opacity: .25;\r\n      }\r\n\r\n      .cls-34 {\r\n        clip-path: url(#clippath-10297);\r\n      }\r\n\r\n      .cls-35 {\r\n        clip-path: url(#clippath-60);\r\n      }\r\n\r\n      .cls-36 {\r\n        clip-path: url(#clippath-15);\r\n      }\r\n\r\n      .cls-343 {\r\n        fill: url(#linear-gradient-130);\r\n      }\r\n\r\n      .cls-475 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-37 {\r\n        clip-path: url(#clippath-2878);\r\n      }\r\n\r\n      .cls-476 {\r\n        clip-path: url(#clippath-1954);\r\n      }\r\n\r\n      .cls-38 {\r\n        clip-path: url(#clippath-1020);\r\n      }\r\n\r\n      .cls-39 {\r\n        clip-path: url(#clippath-9834);\r\n      }\r\n\r\n      .cls-40 {\r\n        clip-path: url(#clippath-31);\r\n      }\r\n\r\n      .cls-41 {\r\n        clip-path: url(#clippath-2413);\r\n      }\r\n\r\n      .cls-344 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-42 {\r\n        clip-path: url(#clippath-5195);\r\n      }\r\n\r\n      .cls-477 {\r\n        mask: url(#mask-17);\r\n      }\r\n\r\n      .cls-43 {\r\n        clip-path: url(#clippath-3340);\r\n      }\r\n\r\n      .cls-44 {\r\n        clip-path: url(#clippath-2876);\r\n      }\r\n\r\n      .cls-45 {\r\n        clip-path: url(#clippath-65);\r\n      }\r\n\r\n      .cls-46 {\r\n        clip-path: url(#clippath-53);\r\n      }\r\n\r\n      .cls-478 {\r\n        clip-path: url(#clippath-10770);\r\n      }\r\n\r\n      .cls-345 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-47 {\r\n        clip-path: url(#clippath-63);\r\n      }\r\n\r\n      .cls-48 {\r\n        clip-path: url(#clippath-4732);\r\n      }\r\n\r\n      .cls-49 {\r\n        clip-path: url(#clippath-72);\r\n      }\r\n\r\n      .cls-50 {\r\n        clip-path: url(#clippath-9838);\r\n      }\r\n\r\n      .cls-51 {\r\n        clip-path: url(#clippath-52);\r\n      }\r\n\r\n      .cls-479 {\r\n        clip-path: url(#clippath-4274);\r\n      }\r\n\r\n      .cls-52 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .cls-53 {\r\n        clip-path: url(#clippath-8903);\r\n      }\r\n\r\n      .cls-346 {\r\n        fill: url(#linear-gradient-76);\r\n      }\r\n\r\n      .cls-54 {\r\n        clip-path: url(#clippath-10299);\r\n      }\r\n\r\n      .cls-480 {\r\n        clip-path: url(#clippath-5666);\r\n      }\r\n\r\n      .cls-55 {\r\n        clip-path: url(#clippath-97);\r\n      }\r\n\r\n      .cls-347 {\r\n        fill: url(#linear-gradient-124);\r\n      }\r\n\r\n      .cls-56 {\r\n        clip-path: url(#clippath-58);\r\n      }\r\n\r\n      .cls-57 {\r\n        clip-path: url(#clippath-7052);\r\n      }\r\n\r\n      .cls-58 {\r\n        clip-path: url(#clippath-557);\r\n      }\r\n\r\n      .cls-59 {\r\n        clip-path: url(#clippath-1953);\r\n      }\r\n\r\n      .cls-60 {\r\n        clip-path: url(#clippath-3798);\r\n      }\r\n\r\n      .cls-61 {\r\n        clip-path: url(#clippath-1478);\r\n      }\r\n\r\n      .cls-481 {\r\n        clip-path: url(#clippath-83);\r\n      }\r\n\r\n      .cls-62 {\r\n        clip-path: url(#clippath-8902);\r\n      }\r\n\r\n      .cls-63 {\r\n        clip-path: url(#clippath-6125);\r\n      }\r\n\r\n      .cls-64 {\r\n        clip-path: url(#clippath-8908);\r\n      }\r\n\r\n      .cls-482 {\r\n        mask: url(#mask-2);\r\n      }\r\n\r\n      .cls-65 {\r\n        clip-path: url(#clippath-10758);\r\n      }\r\n\r\n      .cls-483 {\r\n        clip-path: url(#clippath-8447);\r\n      }\r\n\r\n      .cls-66 {\r\n        clip-path: url(#clippath-4734);\r\n      }\r\n\r\n      .cls-67 {\r\n        clip-path: url(#clippath-9835);\r\n      }\r\n\r\n      .cls-68 {\r\n        clip-path: url(#clippath-2409);\r\n      }\r\n\r\n      .cls-484 {\r\n        clip-path: url(#clippath-13);\r\n      }\r\n\r\n      .cls-69 {\r\n        clip-path: url(#clippath-1018);\r\n      }\r\n\r\n      .cls-485 {\r\n        clip-path: url(#clippath-1487);\r\n      }\r\n\r\n      .cls-70 {\r\n        clip-path: url(#clippath-552);\r\n      }\r\n\r\n      .cls-71 {\r\n        clip-path: url(#clippath-3334);\r\n      }\r\n\r\n      .cls-348 {\r\n        fill: url(#linear-gradient-42);\r\n      }\r\n\r\n      .cls-72 {\r\n        clip-path: url(#clippath-9833);\r\n      }\r\n\r\n      .cls-73 {\r\n        clip-path: url(#clippath-6118);\r\n      }\r\n\r\n      .cls-486 {\r\n        clip-path: url(#clippath-37);\r\n      }\r\n\r\n      .cls-74 {\r\n        clip-path: url(#clippath-55);\r\n      }\r\n\r\n      .cls-75 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-76 {\r\n        clip-path: url(#clippath-6123);\r\n      }\r\n\r\n      .cls-487 {\r\n        clip-path: url(#clippath-9839);\r\n      }\r\n\r\n      .cls-77 {\r\n        clip-path: url(#clippath-8913);\r\n      }\r\n\r\n      .cls-78 {\r\n        clip-path: url(#clippath-2411);\r\n      }\r\n\r\n      .cls-488 {\r\n        clip-path: url(#clippath-25);\r\n      }\r\n\r\n      .cls-79 {\r\n        clip-path: url(#clippath-1489);\r\n      }\r\n\r\n      .cls-80 {\r\n        clip-path: url(#clippath-36);\r\n      }\r\n\r\n      .cls-489 {\r\n        clip-path: url(#clippath-98);\r\n      }\r\n\r\n      .cls-81 {\r\n        clip-path: url(#clippath-3341);\r\n      }\r\n\r\n      .cls-82 {\r\n        clip-path: url(#clippath-33);\r\n      }\r\n\r\n      .cls-473 {\r\n        font-size: 31.57px;\r\n      }\r\n\r\n      .cls-473, .cls-474 {\r\n        font-family: Arial-BoldMT, Arial;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-473, .cls-474, .cls-387 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-83 {\r\n        clip-path: url(#clippath-10300);\r\n      }\r\n\r\n      .cls-84 {\r\n        clip-path: url(#clippath-555);\r\n      }\r\n\r\n      .cls-349 {\r\n        fill: url(#linear-gradient-104);\r\n      }\r\n\r\n      .cls-85 {\r\n        clip-path: url(#clippath-1943);\r\n      }\r\n\r\n      .cls-86 {\r\n        clip-path: url(#clippath-11229);\r\n      }\r\n\r\n      .cls-87 {\r\n        clip-path: url(#clippath-2877);\r\n      }\r\n\r\n      .cls-88 {\r\n        clip-path: url(#clippath-3345);\r\n      }\r\n\r\n      .cls-89 {\r\n        clip-path: url(#clippath-92);\r\n      }\r\n\r\n      .cls-90 {\r\n        clip-path: url(#clippath-553);\r\n      }\r\n\r\n      .cls-490 {\r\n        mask: url(#mask-13);\r\n      }\r\n\r\n      .cls-350 {\r\n        fill: url(#linear-gradient-95);\r\n      }\r\n\r\n      .cls-91 {\r\n        clip-path: url(#clippath-77);\r\n      }\r\n\r\n      .cls-92 {\r\n        clip-path: url(#clippath-5201);\r\n      }\r\n\r\n      .cls-93 {\r\n        clip-path: url(#clippath-1025);\r\n      }\r\n\r\n      .cls-351 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-94 {\r\n        clip-path: url(#clippath-7049);\r\n      }\r\n\r\n      .cls-95 {\r\n        clip-path: url(#clippath-79);\r\n      }\r\n\r\n      .cls-96 {\r\n        clip-path: url(#clippath-4727);\r\n      }\r\n\r\n      .cls-97 {\r\n        clip-path: url(#clippath-2412);\r\n      }\r\n\r\n      .cls-98 {\r\n        clip-path: url(#clippath-4268);\r\n      }\r\n\r\n      .cls-99 {\r\n        clip-path: url(#clippath-5654);\r\n      }\r\n\r\n      .cls-352 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-491 {\r\n        clip-path: url(#clippath-10767);\r\n      }\r\n\r\n      .cls-353 {\r\n        fill: url(#linear-gradient-106);\r\n      }\r\n\r\n      .cls-100 {\r\n        clip-path: url(#clippath-11228);\r\n      }\r\n\r\n      .cls-101 {\r\n        clip-path: url(#clippath-6121);\r\n      }\r\n\r\n      .cls-102 {\r\n        clip-path: url(#clippath-66);\r\n      }\r\n\r\n      .cls-492 {\r\n        mask: url(#mask-3);\r\n      }\r\n\r\n      .cls-103 {\r\n        clip-path: url(#clippath-3337);\r\n      }\r\n\r\n      .cls-354 {\r\n        fill: url(#linear-gradient-101);\r\n      }\r\n\r\n      .cls-355 {\r\n        fill: url(#linear-gradient-81);\r\n      }\r\n\r\n      .cls-104 {\r\n        clip-path: url(#clippath-42);\r\n      }\r\n\r\n      .cls-105 {\r\n        clip-path: url(#clippath-5193);\r\n      }\r\n\r\n      .cls-106 {\r\n        clip-path: url(#clippath-561);\r\n      }\r\n\r\n      .cls-107 {\r\n        clip-path: url(#clippath-2873);\r\n      }\r\n\r\n      .cls-356 {\r\n        fill: url(#linear-gradient-73);\r\n      }\r\n\r\n      .cls-108 {\r\n        clip-path: url(#clippath-5661);\r\n      }\r\n\r\n      .cls-357 {\r\n        fill: url(#linear-gradient-91);\r\n      }\r\n\r\n      .cls-493 {\r\n        clip-path: url(#clippath-5663);\r\n      }\r\n\r\n      .cls-109 {\r\n        clip-path: url(#clippath-5196);\r\n      }\r\n\r\n      .cls-110 {\r\n        clip-path: url(#clippath-62);\r\n      }\r\n\r\n      .cls-111 {\r\n        clip-path: url(#clippath-10305);\r\n      }\r\n\r\n      .cls-112 {\r\n        clip-path: url(#clippath-4);\r\n      }\r\n\r\n      .cls-113 {\r\n        clip-path: url(#clippath-29);\r\n      }\r\n\r\n      .cls-358 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-494 {\r\n        clip-path: url(#clippath-3810);\r\n      }\r\n\r\n      .cls-495 {\r\n        mask: url(#mask-31);\r\n      }\r\n\r\n      .cls-114 {\r\n        clip-path: url(#clippath-3339);\r\n      }\r\n\r\n      .cls-115 {\r\n        clip-path: url(#clippath-4262);\r\n      }\r\n\r\n      .cls-359 {\r\n        fill: url(#linear-gradient-83);\r\n      }\r\n\r\n      .cls-359, .cls-361, .cls-367, .cls-368, .cls-370, .cls-379, .cls-381, .cls-397, .cls-399, .cls-400, .cls-412, .cls-438 {\r\n        opacity: .48;\r\n      }\r\n\r\n      .cls-116 {\r\n        clip-path: url(#clippath-6590);\r\n      }\r\n\r\n      .cls-117 {\r\n        clip-path: url(#clippath-8);\r\n      }\r\n\r\n      .cls-118 {\r\n        clip-path: url(#clippath-56);\r\n      }\r\n\r\n      .cls-360 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-120 {\r\n        clip-path: url(#clippath-10301);\r\n      }\r\n\r\n      .cls-121 {\r\n        clip-path: url(#clippath-2414);\r\n      }\r\n\r\n      .cls-496 {\r\n        mask: url(#mask-30);\r\n      }\r\n\r\n      .cls-361 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-122 {\r\n        clip-path: url(#clippath-11222);\r\n      }\r\n\r\n      .cls-362 {\r\n        fill: url(#linear-gradient-103);\r\n      }\r\n\r\n      .cls-123 {\r\n        clip-path: url(#clippath-70);\r\n      }\r\n\r\n      .cls-363 {\r\n        fill: url(#linear-gradient-71);\r\n      }\r\n\r\n      .cls-364 {\r\n        fill: url(#linear-gradient-58);\r\n      }\r\n\r\n      .cls-497 {\r\n        clip-path: url(#clippath-2882);\r\n      }\r\n\r\n      .cls-365 {\r\n        fill: url(#linear-gradient-63);\r\n      }\r\n\r\n      .cls-124 {\r\n        clip-path: url(#clippath-7511);\r\n      }\r\n\r\n      .cls-366 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-498 {\r\n        clip-path: url(#clippath-5199);\r\n      }\r\n\r\n      .cls-125 {\r\n        clip-path: url(#clippath-1015);\r\n      }\r\n\r\n      .cls-367 {\r\n        fill: url(#linear-gradient-128);\r\n      }\r\n\r\n      .cls-368 {\r\n        fill: url(#linear-gradient-125);\r\n      }\r\n\r\n      .cls-126 {\r\n        clip-path: url(#clippath-18);\r\n      }\r\n\r\n      .cls-499 {\r\n        mask: url(#mask-9);\r\n      }\r\n\r\n      .cls-369 {\r\n        fill: url(#linear-gradient-122);\r\n      }\r\n\r\n      .cls-127 {\r\n        clip-path: url(#clippath-8906);\r\n      }\r\n\r\n      .cls-500 {\r\n        clip-path: url(#clippath-3807);\r\n      }\r\n\r\n      .cls-501 {\r\n        clip-path: url(#clippath-10306);\r\n      }\r\n\r\n      .cls-128 {\r\n        clip-path: url(#clippath-9837);\r\n      }\r\n\r\n      .cls-502 {\r\n        clip-path: url(#clippath-1951);\r\n      }\r\n\r\n      .cls-129 {\r\n        clip-path: url(#clippath-1019);\r\n      }\r\n\r\n      .cls-130 {\r\n        clip-path: url(#clippath-67);\r\n      }\r\n\r\n      .cls-131 {\r\n        clip-path: url(#clippath-5657);\r\n      }\r\n\r\n      .cls-370 {\r\n        fill: url(#linear-gradient-115);\r\n      }\r\n\r\n      .cls-474 {\r\n        font-size: 32.58px;\r\n      }\r\n\r\n      .cls-132 {\r\n        clip-path: url(#clippath-40);\r\n      }\r\n\r\n      .cls-133, .cls-178, .cls-202 {\r\n        stroke-width: 6px;\r\n      }\r\n\r\n      .cls-371 {\r\n        fill: url(#linear-gradient-120);\r\n      }\r\n\r\n      .cls-503 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-134 {\r\n        clip-path: url(#clippath-78);\r\n      }\r\n\r\n      .cls-135 {\r\n        clip-path: url(#clippath-3800);\r\n      }\r\n\r\n      .cls-136 {\r\n        clip-path: url(#clippath-84);\r\n      }\r\n\r\n      .cls-372 {\r\n        fill: url(#linear-gradient-41);\r\n      }\r\n\r\n      .cls-504 {\r\n        mask: url(#mask-12);\r\n      }\r\n\r\n      .cls-137 {\r\n        clip-path: url(#clippath-1016);\r\n      }\r\n\r\n      .cls-138 {\r\n        clip-path: url(#clippath-8909);\r\n      }\r\n\r\n      .cls-139 {\r\n        clip-path: url(#clippath-10759);\r\n      }\r\n\r\n      .cls-373 {\r\n        fill: url(#linear-gradient-89);\r\n      }\r\n\r\n      .cls-140 {\r\n        clip-path: url(#clippath-10296);\r\n      }\r\n\r\n      .cls-141 {\r\n        clip-path: url(#clippath-3804);\r\n      }\r\n\r\n      .cls-142 {\r\n        clip-path: url(#clippath-7980);\r\n      }\r\n\r\n      .cls-143 {\r\n        clip-path: url(#clippath-4270);\r\n      }\r\n\r\n      .cls-374 {\r\n        fill: url(#linear-gradient-40);\r\n      }\r\n\r\n      .cls-505 {\r\n        clip-path: url(#clippath-10303);\r\n      }\r\n\r\n      .cls-506 {\r\n        clip-path: url(#clippath-9842);\r\n      }\r\n\r\n      .cls-375 {\r\n        fill: url(#linear-gradient-66);\r\n      }\r\n\r\n      .cls-507 {\r\n        mask: url(#mask-5);\r\n      }\r\n\r\n      .cls-144 {\r\n        clip-path: url(#clippath-9371);\r\n      }\r\n\r\n      .cls-145 {\r\n        clip-path: url(#clippath-57);\r\n      }\r\n\r\n      .cls-376 {\r\n        fill: url(#linear-gradient-126);\r\n      }\r\n\r\n      .cls-146 {\r\n        clip-path: url(#clippath-3802);\r\n      }\r\n\r\n      .cls-147 {\r\n        clip-path: url(#clippath-81);\r\n      }\r\n\r\n      .cls-377 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-378 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-379 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-148 {\r\n        clip-path: url(#clippath-1479);\r\n      }\r\n\r\n      .cls-149 {\r\n        clip-path: url(#clippath-11224);\r\n      }\r\n\r\n      .cls-508 {\r\n        clip-path: url(#clippath-8911);\r\n      }\r\n\r\n      .cls-380 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-150 {\r\n        clip-path: url(#clippath-2870);\r\n      }\r\n\r\n      .cls-509 {\r\n        clip-path: url(#clippath-6591);\r\n      }\r\n\r\n      .cls-151 {\r\n        clip-path: url(#clippath-7978);\r\n      }\r\n\r\n      .cls-152 {\r\n        clip-path: url(#clippath-5191);\r\n      }\r\n\r\n      .cls-153 {\r\n        clip-path: url(#clippath-9367);\r\n      }\r\n\r\n      .cls-381 {\r\n        fill: url(#linear-gradient-64);\r\n      }\r\n\r\n      .cls-382 {\r\n        fill: url(#linear-gradient-43);\r\n      }\r\n\r\n      .cls-154 {\r\n        clip-path: url(#clippath-556);\r\n      }\r\n\r\n      .cls-155 {\r\n        clip-path: url(#clippath-3335);\r\n      }\r\n\r\n      .cls-383 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-384 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-156 {\r\n        clip-path: url(#clippath-21);\r\n      }\r\n\r\n      .cls-510 {\r\n        clip-path: url(#clippath-7055);\r\n      }\r\n\r\n      .cls-511 {\r\n        clip-path: url(#clippath-9378);\r\n      }\r\n\r\n      .cls-385 {\r\n        fill: url(#linear-gradient-54);\r\n      }\r\n\r\n      .cls-157 {\r\n        clip-path: url(#clippath-32);\r\n      }\r\n\r\n      .cls-386 {\r\n        fill: url(#linear-gradient-55);\r\n      }\r\n\r\n      .cls-388 {\r\n        fill: url(#linear-gradient-110);\r\n      }\r\n\r\n      .cls-158 {\r\n        clip-path: url(#clippath-6582);\r\n      }\r\n\r\n      .cls-159 {\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-159, .cls-202 {\r\n        stroke-linecap: square;\r\n      }\r\n\r\n      .cls-389 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-160 {\r\n        clip-path: url(#clippath-1949);\r\n      }\r\n\r\n      .cls-161 {\r\n        clip-path: url(#clippath-9373);\r\n      }\r\n\r\n      .cls-162 {\r\n        clip-path: url(#clippath-7516);\r\n      }\r\n\r\n      .cls-390 {\r\n        fill: url(#linear-gradient-50);\r\n      }\r\n\r\n      .cls-163 {\r\n        clip-path: url(#clippath-3809);\r\n      }\r\n\r\n      .cls-164 {\r\n        clip-path: url(#clippath-24);\r\n      }\r\n\r\n      .cls-391 {\r\n        fill: url(#linear-gradient-60);\r\n      }\r\n\r\n      .cls-165 {\r\n        clip-path: url(#clippath-9370);\r\n      }\r\n\r\n      .cls-512 {\r\n        clip-path: url(#clippath-95);\r\n      }\r\n\r\n      .cls-392 {\r\n        fill: url(#linear-gradient-59);\r\n      }\r\n\r\n      .cls-393 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-513 {\r\n        mask: url(#mask-20);\r\n      }\r\n\r\n      .cls-166 {\r\n        clip-path: url(#clippath-43);\r\n      }\r\n\r\n      .cls-167 {\r\n        clip-path: url(#clippath-5658);\r\n      }\r\n\r\n      .cls-168 {\r\n        clip-path: url(#clippath-5662);\r\n      }\r\n\r\n      .cls-169 {\r\n        clip-path: url(#clippath-7053);\r\n      }\r\n\r\n      .cls-170 {\r\n        clip-path: url(#clippath-20);\r\n      }\r\n\r\n      .cls-394 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-171 {\r\n        clip-path: url(#clippath-7517);\r\n      }\r\n\r\n      .cls-172 {\r\n        clip-path: url(#clippath-2407);\r\n      }\r\n\r\n      .cls-395 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-514 {\r\n        clip-path: url(#clippath-4271);\r\n      }\r\n\r\n      .cls-173 {\r\n        clip-path: url(#clippath-7515);\r\n      }\r\n\r\n      .cls-174 {\r\n        clip-path: url(#clippath-6589);\r\n      }\r\n\r\n      .cls-175 {\r\n        clip-path: url(#clippath-4269);\r\n      }\r\n\r\n      .cls-396 {\r\n        fill: url(#linear-gradient-52);\r\n      }\r\n\r\n      .cls-515 {\r\n        clip-path: url(#clippath-6127);\r\n      }\r\n\r\n      .cls-516 {\r\n        clip-path: url(#clippath-1023);\r\n      }\r\n\r\n      .cls-397 {\r\n        fill: url(#linear-gradient-93);\r\n      }\r\n\r\n      .cls-176 {\r\n        clip-path: url(#clippath-7981);\r\n      }\r\n\r\n      .cls-517 {\r\n        clip-path: url(#clippath-3343);\r\n      }\r\n\r\n      .cls-398 {\r\n        fill: url(#linear-gradient-45);\r\n      }\r\n\r\n      .cls-177 {\r\n        clip-path: url(#clippath-10762);\r\n      }\r\n\r\n      .cls-399 {\r\n        fill: url(#linear-gradient-61);\r\n      }\r\n\r\n      .cls-178 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-179 {\r\n        clip-path: url(#clippath-8442);\r\n      }\r\n\r\n      .cls-518 {\r\n        mask: url(#mask-25);\r\n      }\r\n\r\n      .cls-180 {\r\n        clip-path: url(#clippath-10764);\r\n      }\r\n\r\n      .cls-181 {\r\n        clip-path: url(#clippath-64);\r\n      }\r\n\r\n      .cls-182 {\r\n        clip-path: url(#clippath-4273);\r\n      }\r\n\r\n      .cls-183 {\r\n        clip-path: url(#clippath-3338);\r\n      }\r\n\r\n      .cls-184 {\r\n        clip-path: url(#clippath-4726);\r\n      }\r\n\r\n      .cls-519 {\r\n        mask: url(#mask-8);\r\n      }\r\n\r\n      .cls-185 {\r\n        clip-path: url(#clippath-22);\r\n      }\r\n\r\n      .cls-400 {\r\n        fill: url(#linear-gradient-96);\r\n      }\r\n\r\n      .cls-186 {\r\n        clip-path: url(#clippath-1483);\r\n      }\r\n\r\n      .cls-520 {\r\n        clip-path: url(#clippath-1026);\r\n      }\r\n\r\n      .cls-187 {\r\n        clip-path: url(#clippath-7975);\r\n      }\r\n\r\n      .cls-188 {\r\n        clip-path: url(#clippath-10298);\r\n      }\r\n\r\n      .cls-189 {\r\n        clip-path: url(#clippath-2875);\r\n      }\r\n\r\n      .cls-521 {\r\n        clip-path: url(#clippath-562);\r\n      }\r\n\r\n      .cls-401 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-522 {\r\n        clip-path: url(#clippath-11231);\r\n      }\r\n\r\n      .cls-190 {\r\n        clip-path: url(#clippath-9830);\r\n      }\r\n\r\n      .cls-402 {\r\n        fill: url(#linear-gradient-39);\r\n      }\r\n\r\n      .cls-191 {\r\n        clip-path: url(#clippath-1486);\r\n      }\r\n\r\n      .cls-523 {\r\n        mask: url(#mask-4);\r\n      }\r\n\r\n      .cls-192 {\r\n        clip-path: url(#clippath-9831);\r\n      }\r\n\r\n      .cls-403 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-524 {\r\n        mask: url(#mask-24);\r\n      }\r\n\r\n      .cls-193 {\r\n        clip-path: url(#clippath-10769);\r\n      }\r\n\r\n      .cls-194 {\r\n        clip-path: url(#clippath-82);\r\n      }\r\n\r\n      .cls-195 {\r\n        clip-path: url(#clippath-6);\r\n      }\r\n\r\n      .cls-196 {\r\n        clip-path: url(#clippath-1482);\r\n      }\r\n\r\n      .cls-197 {\r\n        clip-path: url(#clippath-551);\r\n      }\r\n\r\n      .cls-198 {\r\n        clip-path: url(#clippath-7057);\r\n      }\r\n\r\n      .cls-199 {\r\n        clip-path: url(#clippath-10295);\r\n      }\r\n\r\n      .cls-200 {\r\n        clip-path: url(#clippath-7985);\r\n      }\r\n\r\n      .cls-201 {\r\n        clip-path: url(#clippath-4731);\r\n      }\r\n\r\n      .cls-404 {\r\n        fill: url(#linear-gradient-77);\r\n      }\r\n\r\n      .cls-405 {\r\n        fill: url(#linear-gradient-119);\r\n      }\r\n\r\n      .cls-525 {\r\n        letter-spacing: -.09em;\r\n      }\r\n\r\n      .cls-203 {\r\n        clip-path: url(#clippath-7518);\r\n      }\r\n\r\n      .cls-406 {\r\n        fill: url(#linear-gradient-69);\r\n      }\r\n\r\n      .cls-204 {\r\n        clip-path: url(#clippath-17);\r\n      }\r\n\r\n      .cls-205 {\r\n        clip-path: url(#clippath-8904);\r\n      }\r\n\r\n      .cls-206 {\r\n        clip-path: url(#clippath-69);\r\n      }\r\n\r\n      .cls-207 {\r\n        clip-path: url(#clippath-6585);\r\n      }\r\n\r\n      .cls-208 {\r\n        clip-path: url(#clippath-6583);\r\n      }\r\n\r\n      .cls-526 {\r\n        mask: url(#mask-19);\r\n      }\r\n\r\n      .cls-209 {\r\n        clip-path: url(#clippath-5192);\r\n      }\r\n\r\n      .cls-210 {\r\n        clip-path: url(#clippath-1945);\r\n      }\r\n\r\n      .cls-407 {\r\n        fill: url(#linear-gradient-94);\r\n      }\r\n\r\n      .cls-527 {\r\n        clip-path: url(#clippath-7983);\r\n      }\r\n\r\n      .cls-528 {\r\n        mask: url(#mask-15);\r\n      }\r\n\r\n      .cls-211 {\r\n        clip-path: url(#clippath-48);\r\n      }\r\n\r\n      .cls-408 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-409 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-410 {\r\n        fill: url(#linear-gradient-129);\r\n      }\r\n\r\n      .cls-212 {\r\n        clip-path: url(#clippath-1944);\r\n      }\r\n\r\n      .cls-213 {\r\n        clip-path: url(#clippath-5660);\r\n      }\r\n\r\n      .cls-214 {\r\n        clip-path: url(#clippath-4264);\r\n      }\r\n\r\n      .cls-215 {\r\n        clip-path: url(#clippath-7047);\r\n      }\r\n\r\n      .cls-529 {\r\n        clip-path: url(#clippath-61);\r\n      }\r\n\r\n      .cls-216 {\r\n        clip-path: url(#clippath-5194);\r\n      }\r\n\r\n      .cls-217 {\r\n        clip-path: url(#clippath-3799);\r\n      }\r\n\r\n      .cls-530 {\r\n        clip-path: url(#clippath-4738);\r\n      }\r\n\r\n      .cls-411 {\r\n        fill: url(#linear-gradient-100);\r\n      }\r\n\r\n      .cls-218 {\r\n        clip-path: url(#clippath-10766);\r\n      }\r\n\r\n      .cls-219 {\r\n        clip-path: url(#clippath-1480);\r\n      }\r\n\r\n      .cls-220 {\r\n        clip-path: url(#clippath-2406);\r\n      }\r\n\r\n      .cls-221 {\r\n        clip-path: url(#clippath-4728);\r\n      }\r\n\r\n      .cls-222 {\r\n        clip-path: url(#clippath-5190);\r\n      }\r\n\r\n      .cls-223 {\r\n        clip-path: url(#clippath-19);\r\n      }\r\n\r\n      .cls-224 {\r\n        clip-path: url(#clippath-1946);\r\n      }\r\n\r\n      .cls-225 {\r\n        clip-path: url(#clippath-7);\r\n      }\r\n\r\n      .cls-226 {\r\n        clip-path: url(#clippath-1947);\r\n      }\r\n\r\n      .cls-412 {\r\n        fill: url(#linear-gradient-51);\r\n      }\r\n\r\n      .cls-413 {\r\n        fill: url(#linear-gradient-82);\r\n      }\r\n\r\n      .cls-414 {\r\n        fill: url(#linear-gradient-105);\r\n      }\r\n\r\n      .cls-227 {\r\n        clip-path: url(#clippath-38);\r\n      }\r\n\r\n      .cls-228 {\r\n        clip-path: url(#clippath-46);\r\n      }\r\n\r\n      .cls-229 {\r\n        clip-path: url(#clippath-6119);\r\n      }\r\n\r\n      .cls-230 {\r\n        clip-path: url(#clippath-1017);\r\n      }\r\n\r\n      .cls-531 {\r\n        clip-path: url(#clippath-8914);\r\n      }\r\n\r\n      .cls-231 {\r\n        clip-path: url(#clippath-9368);\r\n      }\r\n\r\n      .cls-532 {\r\n        mask: url(#mask-6);\r\n      }\r\n\r\n      .cls-232 {\r\n        clip-path: url(#clippath-10302);\r\n      }\r\n\r\n      .cls-415 {\r\n        fill: url(#linear-gradient-53);\r\n      }\r\n\r\n      .cls-416 {\r\n        fill: url(#linear-gradient-90);\r\n      }\r\n\r\n      .cls-533 {\r\n        clip-path: url(#clippath-7519);\r\n      }\r\n\r\n      .cls-233 {\r\n        clip-path: url(#clippath-1014);\r\n      }\r\n\r\n      .cls-234 {\r\n        clip-path: url(#clippath-34);\r\n      }\r\n\r\n      .cls-235 {\r\n        clip-path: url(#clippath-16);\r\n      }\r\n\r\n      .cls-236 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 7px;\r\n      }\r\n\r\n      .cls-417 {\r\n        fill: url(#linear-gradient-117);\r\n      }\r\n\r\n      .cls-237 {\r\n        clip-path: url(#clippath-8439);\r\n      }\r\n\r\n      .cls-238 {\r\n        clip-path: url(#clippath-9832);\r\n      }\r\n\r\n      .cls-418 {\r\n        fill: url(#linear-gradient-85);\r\n      }\r\n\r\n      .cls-239 {\r\n        clip-path: url(#clippath-87);\r\n      }\r\n\r\n      .cls-419 {\r\n        fill: url(#linear-gradient-65);\r\n      }\r\n\r\n      .cls-240 {\r\n        clip-path: url(#clippath-8449);\r\n      }\r\n\r\n      .cls-241 {\r\n        clip-path: url(#clippath-7050);\r\n      }\r\n\r\n      .cls-420 {\r\n        fill: url(#linear-gradient-132);\r\n      }\r\n\r\n      .cls-242 {\r\n        clip-path: url(#clippath-2417);\r\n      }\r\n\r\n      .cls-243 {\r\n        clip-path: url(#clippath-7976);\r\n      }\r\n\r\n      .cls-421 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-244 {\r\n        clip-path: url(#clippath-9836);\r\n      }\r\n\r\n      .cls-422 {\r\n        fill: url(#linear-gradient-48);\r\n      }\r\n\r\n      .cls-245 {\r\n        clip-path: url(#clippath-5);\r\n      }\r\n\r\n      .cls-246 {\r\n        clip-path: url(#clippath-1942);\r\n      }\r\n\r\n      .cls-247 {\r\n        clip-path: url(#clippath-1021);\r\n      }\r\n\r\n      .cls-423 {\r\n        fill: url(#linear-gradient-49);\r\n      }\r\n\r\n      .cls-248 {\r\n        clip-path: url(#clippath-89);\r\n      }\r\n\r\n      .cls-249 {\r\n        clip-path: url(#clippath-93);\r\n      }\r\n\r\n      .cls-534 {\r\n        mask: url(#mask-16);\r\n      }\r\n\r\n      .cls-424 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-250 {\r\n        clip-path: url(#clippath-6586);\r\n      }\r\n\r\n      .cls-251 {\r\n        clip-path: url(#clippath-4266);\r\n      }\r\n\r\n      .cls-425 {\r\n        fill: url(#linear-gradient-47);\r\n      }\r\n\r\n      .cls-535 {\r\n        clip-path: url(#clippath-8450);\r\n      }\r\n\r\n      .cls-426 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-427 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-252 {\r\n        stroke-width: 4.5px;\r\n      }\r\n\r\n      .cls-536 {\r\n        clip-path: url(#clippath-2879);\r\n      }\r\n\r\n      .cls-537 {\r\n        mask: url(#mask-18);\r\n      }\r\n\r\n      .cls-428 {\r\n        fill: url(#linear-gradient-114);\r\n      }\r\n\r\n      .cls-253 {\r\n        clip-path: url(#clippath-4737);\r\n      }\r\n\r\n      .cls-429 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-254 {\r\n        clip-path: url(#clippath-26);\r\n      }\r\n\r\n      .cls-255 {\r\n        clip-path: url(#clippath-1484);\r\n      }\r\n\r\n      .cls-538 {\r\n        clip-path: url(#clippath-5202);\r\n      }\r\n\r\n      .cls-256 {\r\n        clip-path: url(#clippath-74);\r\n      }\r\n\r\n      .cls-539 {\r\n        clip-path: url(#clippath-6130);\r\n      }\r\n\r\n      .cls-540 {\r\n        clip-path: url(#clippath-7986);\r\n      }\r\n\r\n      .cls-257 {\r\n        clip-path: url(#clippath-2874);\r\n      }\r\n\r\n      .cls-258 {\r\n        clip-path: url(#clippath-3801);\r\n      }\r\n\r\n      .cls-259 {\r\n        clip-path: url(#clippath-2872);\r\n      }\r\n\r\n      .cls-260 {\r\n        clip-path: url(#clippath-91);\r\n      }\r\n\r\n      .cls-261 {\r\n        clip-path: url(#clippath-39);\r\n      }\r\n\r\n      .cls-262 {\r\n        clip-path: url(#clippath-8441);\r\n      }\r\n\r\n      .cls-263 {\r\n        clip-path: url(#clippath-7513);\r\n      }\r\n\r\n      .cls-264 {\r\n        clip-path: url(#clippath-3805);\r\n      }\r\n\r\n      .cls-265 {\r\n        clip-path: url(#clippath-54);\r\n      }\r\n\r\n      .cls-430 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-266 {\r\n        clip-path: url(#clippath-8446);\r\n      }\r\n\r\n      .cls-267 {\r\n        clip-path: url(#clippath-3342);\r\n      }\r\n\r\n      .cls-431 {\r\n        fill: url(#linear-gradient-121);\r\n      }\r\n\r\n      .cls-268 {\r\n        clip-path: url(#clippath-3806);\r\n      }\r\n\r\n      .cls-269 {\r\n        clip-path: url(#clippath-10765);\r\n      }\r\n\r\n      .cls-270 {\r\n        clip-path: url(#clippath-6120);\r\n      }\r\n\r\n      .cls-541 {\r\n        mask: url(#mask-1);\r\n      }\r\n\r\n      .cls-542 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-271 {\r\n        clip-path: url(#clippath-9374);\r\n      }\r\n\r\n      .cls-432 {\r\n        fill: url(#linear-gradient-44);\r\n      }\r\n\r\n      .cls-543 {\r\n        mask: url(#mask-22);\r\n      }\r\n\r\n      .cls-433 {\r\n        fill: url(#linear-gradient-84);\r\n      }\r\n\r\n      .cls-272 {\r\n        clip-path: url(#clippath-11230);\r\n      }\r\n\r\n      .cls-434 {\r\n        fill: url(#linear-gradient-97);\r\n      }\r\n\r\n      .cls-435 {\r\n        fill: url(#linear-gradient-68);\r\n      }\r\n\r\n      .cls-273 {\r\n        clip-path: url(#clippath-45);\r\n      }\r\n\r\n      .cls-544 {\r\n        clip-path: url(#clippath-1490);\r\n      }\r\n\r\n      .cls-436 {\r\n        fill: url(#linear-gradient-72);\r\n      }\r\n\r\n      .cls-274 {\r\n        clip-path: url(#clippath-3);\r\n      }\r\n\r\n      .cls-275 {\r\n        clip-path: url(#clippath-3803);\r\n      }\r\n\r\n      .cls-276 {\r\n        clip-path: url(#clippath-5197);\r\n      }\r\n\r\n      .cls-437 {\r\n        fill: url(#linear-gradient-46);\r\n      }\r\n\r\n      .cls-277 {\r\n        clip-path: url(#clippath-90);\r\n      }\r\n\r\n      .cls-438 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-278 {\r\n        clip-path: url(#clippath-9841);\r\n      }\r\n\r\n      .cls-279 {\r\n        clip-path: url(#clippath-1481);\r\n      }\r\n\r\n      .cls-545 {\r\n        mask: url(#mask-29);\r\n      }\r\n\r\n      .cls-280 {\r\n        clip-path: url(#clippath-10);\r\n      }\r\n\r\n      .cls-281 {\r\n        clip-path: url(#clippath-50);\r\n      }\r\n\r\n      .cls-546 {\r\n        clip-path: url(#clippath-6594);\r\n      }\r\n\r\n      .cls-282 {\r\n        clip-path: url(#clippath-558);\r\n      }\r\n\r\n      .cls-439 {\r\n        fill: url(#linear-gradient-107);\r\n      }\r\n\r\n      .cls-283 {\r\n        clip-path: url(#clippath-4733);\r\n      }\r\n\r\n      .cls-284 {\r\n        clip-path: url(#clippath-8444);\r\n      }\r\n\r\n      .cls-440 {\r\n        fill: url(#linear-gradient-109);\r\n      }\r\n\r\n      .cls-285 {\r\n        clip-path: url(#clippath-6124);\r\n      }\r\n\r\n      .cls-547 {\r\n        clip-path: url(#clippath-3346);\r\n      }\r\n\r\n      .cls-441 {\r\n        fill: url(#linear-gradient-113);\r\n      }\r\n\r\n      .cls-548 {\r\n        mask: url(#mask-7);\r\n      }\r\n\r\n      .cls-286 {\r\n        clip-path: url(#clippath-41);\r\n      }\r\n\r\n      .cls-287 {\r\n        clip-path: url(#clippath-30);\r\n      }\r\n\r\n      .cls-288 {\r\n        clip-path: url(#clippath-1948);\r\n      }\r\n\r\n      .cls-289 {\r\n        clip-path: url(#clippath-7512);\r\n      }\r\n\r\n      .cls-290 {\r\n        clip-path: url(#clippath-7046);\r\n      }\r\n\r\n      .cls-442 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-443 {\r\n        fill: url(#linear-gradient-56);\r\n      }\r\n\r\n      .cls-444 {\r\n        fill: url(#linear-gradient-99);\r\n      }\r\n\r\n      .cls-291 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-549 {\r\n        letter-spacing: -.07em;\r\n      }\r\n\r\n      .cls-445 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-292 {\r\n        clip-path: url(#clippath-80);\r\n      }\r\n\r\n      .cls-446 {\r\n        fill: #1e110e;\r\n      }\r\n\r\n      .cls-447 {\r\n        fill: url(#linear-gradient-87);\r\n      }\r\n\r\n      .cls-448 {\r\n        fill: url(#linear-gradient-70);\r\n      }\r\n\r\n      .cls-293 {\r\n        clip-path: url(#clippath-11223);\r\n      }\r\n\r\n      .cls-294 {\r\n        clip-path: url(#clippath-6126);\r\n      }\r\n\r\n      .cls-449 {\r\n        fill: url(#linear-gradient-78);\r\n      }\r\n\r\n      .cls-295 {\r\n        clip-path: url(#clippath-88);\r\n      }\r\n\r\n      .cls-450 {\r\n        fill: url(#linear-gradient-86);\r\n      }\r\n\r\n      .cls-296 {\r\n        clip-path: url(#clippath-7974);\r\n      }\r\n\r\n      .cls-297 {\r\n        clip-path: url(#clippath-8907);\r\n      }\r\n\r\n      .cls-298 {\r\n        clip-path: url(#clippath-11226);\r\n      }\r\n\r\n      .cls-550 {\r\n        clip-path: url(#clippath-9375);\r\n      }\r\n\r\n      .cls-551 {\r\n        clip-path: url(#clippath-23);\r\n      }\r\n\r\n      .cls-451 {\r\n        fill: url(#linear-gradient-74);\r\n      }\r\n\r\n      .cls-552 {\r\n        clip-path: url(#clippath-7522);\r\n      }\r\n\r\n      .cls-299 {\r\n        clip-path: url(#clippath-11227);\r\n      }\r\n\r\n      .cls-452 {\r\n        fill: url(#linear-gradient-102);\r\n      }\r\n\r\n      .cls-553 {\r\n        clip-path: url(#clippath-4735);\r\n      }\r\n\r\n      .cls-300 {\r\n        clip-path: url(#clippath-6584);\r\n      }\r\n\r\n      .cls-301 {\r\n        clip-path: url(#clippath-4730);\r\n      }\r\n\r\n      .cls-302 {\r\n        clip-path: url(#clippath-5198);\r\n      }\r\n\r\n      .cls-303 {\r\n        clip-path: url(#clippath-28);\r\n      }\r\n\r\n      .cls-304 {\r\n        clip-path: url(#clippath-5659);\r\n      }\r\n\r\n      .cls-554 {\r\n        clip-path: url(#clippath-49);\r\n      }\r\n\r\n      .cls-305 {\r\n        clip-path: url(#clippath-1485);\r\n      }\r\n\r\n      .cls-453 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-306 {\r\n        clip-path: url(#clippath-4729);\r\n      }\r\n\r\n      .cls-307 {\r\n        clip-path: url(#clippath-6587);\r\n      }\r\n\r\n      .cls-454 {\r\n        fill: url(#linear-gradient-118);\r\n      }\r\n\r\n      .cls-308 {\r\n        clip-path: url(#clippath-7521);\r\n      }\r\n\r\n      .cls-555 {\r\n        mask: url(#mask-14);\r\n      }\r\n\r\n      .cls-309 {\r\n        clip-path: url(#clippath-8905);\r\n      }\r\n\r\n      .cls-310 {\r\n        clip-path: url(#clippath-8440);\r\n      }\r\n\r\n      .cls-455 {\r\n        fill: url(#linear-gradient-112);\r\n      }\r\n\r\n      .cls-311 {\r\n        clip-path: url(#clippath-7051);\r\n      }\r\n\r\n      .cls-312 {\r\n        clip-path: url(#clippath-7048);\r\n      }\r\n\r\n      .cls-313 {\r\n        clip-path: url(#clippath-2408);\r\n      }\r\n\r\n      .cls-556 {\r\n        mask: url(#mask-21);\r\n      }\r\n\r\n      .cls-314 {\r\n        clip-path: url(#clippath-9);\r\n      }\r\n\r\n      .cls-315 {\r\n        clip-path: url(#clippath-7982);\r\n      }\r\n\r\n      .cls-456 {\r\n        fill: url(#linear-gradient-123);\r\n      }\r\n\r\n      .cls-557 {\r\n        clip-path: url(#clippath-2415);\r\n      }\r\n\r\n      .cls-558 {\r\n        mask: url(#mask-11);\r\n      }\r\n\r\n      .cls-559 {\r\n        mask: url(#mask-28);\r\n      }\r\n\r\n      .cls-316 {\r\n        clip-path: url(#clippath-44);\r\n      }\r\n\r\n      .cls-457 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n\r\n      .cls-317 {\r\n        clip-path: url(#clippath-10760);\r\n      }\r\n\r\n      .cls-458 {\r\n        fill: url(#linear-gradient-80);\r\n      }\r\n\r\n      .cls-560 {\r\n        clip-path: url(#clippath-71);\r\n      }\r\n\r\n      .cls-318 {\r\n        clip-path: url(#clippath-3336);\r\n      }\r\n\r\n      .cls-561 {\r\n        clip-path: url(#clippath-85);\r\n      }\r\n\r\n      .cls-459 {\r\n        fill: url(#linear-gradient-116);\r\n      }\r\n\r\n      .cls-562 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-319 {\r\n        clip-path: url(#clippath-2410);\r\n      }\r\n\r\n      .cls-320 {\r\n        clip-path: url(#clippath-8438);\r\n      }\r\n\r\n      .cls-321 {\r\n        clip-path: url(#clippath-5665);\r\n      }\r\n\r\n      .cls-322 {\r\n        clip-path: url(#clippath-550);\r\n      }\r\n\r\n      .cls-460 {\r\n        fill: url(#linear-gradient-79);\r\n      }\r\n\r\n      .cls-563 {\r\n        clip-path: url(#clippath-2418);\r\n      }\r\n\r\n      .cls-323 {\r\n        clip-path: url(#clippath-8443);\r\n      }\r\n\r\n      .cls-324 {\r\n        clip-path: url(#clippath-7054);\r\n      }\r\n\r\n      .cls-325 {\r\n        clip-path: url(#clippath-8445);\r\n      }\r\n\r\n      .cls-564 {\r\n        clip-path: url(#clippath-7058);\r\n      }\r\n\r\n      .cls-461 {\r\n        fill: url(#linear-gradient-111);\r\n      }\r\n\r\n      .cls-326 {\r\n        clip-path: url(#clippath-4263);\r\n      }\r\n\r\n      .cls-327 {\r\n        clip-path: url(#clippath-7979);\r\n      }\r\n\r\n      .cls-328 {\r\n        clip-path: url(#clippath-11225);\r\n      }\r\n\r\n      .cls-462 {\r\n        fill: url(#linear-gradient-108);\r\n      }\r\n\r\n      .cls-565 {\r\n        clip-path: url(#clippath-35);\r\n      }\r\n\r\n      .cls-329 {\r\n        clip-path: url(#clippath-68);\r\n      }\r\n\r\n      .cls-463 {\r\n        fill: url(#linear-gradient-75);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1153.63,
    y1: 1659.3,
    x2: 1153.63,
    y2: 1717.51,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ef8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1122.16,
    y1: 1768,
    x2: 1122.16,
    y2: 1714.27,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1185.36,
    y1: 1768,
    x2: 1185.36,
    y2: 1714.27,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-314",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1470.4,
    y1: 2671.33,
    x2: 1410.03,
    y2: 2688.22,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 143.2,
    y: -5.7,
    width: 28.7,
    height: 176.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-466"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-453",
    points: "164.3 121.7 162.2 122.8 158 170.7 171.9 158.8 164.3 121.7"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1470.4,
    y1: 2671.33,
    x2: 1410.03,
    y2: 2688.22,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1399.75,
    y1: 2665.76,
    x2: 1392.79,
    y2: 2767.43,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 143.2,
    y: -5.7,
    width: 85.5,
    height: 176.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-2",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-551"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-345",
    points: "222.4 121.7 224.4 122.8 228.7 170.7 214.8 158.8 222.4 121.7"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1399.75,
    y1: 2665.76,
    x2: 1392.79,
    y2: 2767.43,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1153.66,
    y1: 1720.65,
    x2: 1153.66,
    y2: 1728.2,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-303",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1429.25,
    y1: 2648.45,
    x2: 1425.65,
    y2: 2719.55,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 143.2,
    y: -5.7,
    width: 68.3,
    height: 174.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-3",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-565"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-408",
    points: "211.5 159.5 175.5 159.5 175.5 169.2 178.1 169.2 178.1 162.6 211.5 162.6 211.5 159.5"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1429.25,
    y1: 2648.45,
    x2: 1425.65,
    y2: 2719.55,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1429.25,
    y1: 2648.45,
    x2: 1425.65,
    y2: 2719.55,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1138.36,
    y1: 1719.19,
    x2: 1169.06,
    y2: 1719.19,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1153.81,
    y1: 1736.13,
    x2: 1153.81,
    y2: 1816.13,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1461.99,
    y1: 2790.76,
    x2: 1372.16,
    y2: 2781.71,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1411.92,
    y1: 2758.59,
    x2: 1688.47,
    y2: 2528.62,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 143.2,
    y: -5.7,
    width: 50.2,
    height: 165.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-4",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-472"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "m162.2,85.5c0,8.3.3,16,.8,23.1,2.3,32.5,9.1,50.9,9.1,50.9h8.8C157.6,76.6,193,3,193.4,2.1c-.4.5-20,23.7-27.9,56.6-2,8.4-3.3,17.5-3.3,26.8Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1411.92,
    y1: 2758.59,
    x2: 1688.47,
    y2: 2528.62,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1430.7,
    y1: 2713.79,
    x2: 1352.02,
    y2: 2877.46,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 143.2,
    y: -5.7,
    width: 81.1,
    height: 165.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-5",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-467"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "m224.3,85.5c0,8.3-.3,16-.8,23.1-2.3,32.5-9.1,50.9-9.1,50.9h-8.8C229,76.6,193.7,3,193.2,2.1c.4.5,20,23.7,27.9,56.6,2,8.4,3.2,17.5,3.2,26.8Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1430.7,
    y1: 2713.79,
    x2: 1352.02,
    y2: 2877.46,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1430.7,
    y1: 2713.79,
    x2: 1352.02,
    y2: 2877.46,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1152.71,
    y1: 1746.66,
    x2: 1152.71,
    y2: 1718.79,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1154.86,
    y1: 1717.58,
    x2: 1154.86,
    y2: 1739.02,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-329",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1437.97,
    y1: 2729.38,
    x2: 1366.46,
    y2: 2777.03,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 143.2,
    y: -5.7,
    width: 63,
    height: 104.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-6",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-560"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-384",
    cx: 192.6,
    cy: 85.2,
    r: 13.6
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1437.97,
    y1: 2729.38,
    x2: 1366.46,
    y2: 2777.03,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1437.97,
    y1: 2729.38,
    x2: 1366.46,
    y2: 2777.03,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1153.76,
    y1: 1817.59,
    x2: 1153.76,
    y2: 1797.62,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1158.08,
    y1: 1797.97,
    x2: 1151.65,
    y2: 1808.03,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1436.79,
    y1: 2749.51,
    x2: 1388.41,
    y2: 2706.91,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 143.2,
    y: -5.7,
    width: 59.1,
    height: 95,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-7",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-481"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "m188.5,77l12.3,12.3c.9-1.4,1.5-3,1.5-4.9,0-4.9-4-8.9-8.9-8.9-1.8.1-3.4.6-4.9,1.5Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1436.79,
    y1: 2749.51,
    x2: 1388.41,
    y2: 2706.91,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1436.79,
    y1: 2749.51,
    x2: 1388.41,
    y2: 2706.91,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "146.1 -2.8 147.1 -2.8 146.1 -1.8 146.1 -2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "144.1 -4.7 143.2 -4.7 144.1 -5.7 144.1 -4.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1429.03,
    y1: 2745.67,
    x2: 1432.95,
    y2: 2707.65,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 143.2,
    y: -5.7,
    width: 55.8,
    height: 98.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-8",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "m184.9,81.7l11.1,11.1c1.1-.4,2.1-.9,3-1.7l-12.5-12.4c-.6,1-1.2,1.9-1.6,3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1429.03,
    y1: 2745.67,
    x2: 1432.95,
    y2: 2707.65,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1429.03,
    y1: 2745.67,
    x2: 1432.95,
    y2: 2707.65,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1221.29,
    y1: 1464.51,
    x2: 1221.29,
    y2: 1571.14,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ef8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1163.66,
    y1: 1663.64,
    x2: 1163.66,
    y2: 1565.2,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1279.36,
    y1: 1663.64,
    x2: 1279.36,
    y2: 1565.2,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-550"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-551"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-552"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-553"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-554"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-555"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-556"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-557"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-558"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-559"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1572.73,
    y1: 2544.12,
    x2: 1462.14,
    y2: 2575.06,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 33.7,
    y: -7,
    width: 52.5,
    height: 323.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-9",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-465"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-421",
    points: "72.3 226.4 68.6 228.3 60.8 316.1 86.2 294.3 72.3 226.4"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1572.73,
    y1: 2544.12,
    x2: 1462.14,
    y2: 2575.06,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-561"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-562"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1014"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1015"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1016"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1017"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1018"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1019"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1020"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1021"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1022"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1023"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1443.26,
    y1: 2533.9,
    x2: 1430.51,
    y2: 2720.16,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 33.7,
    y: -7,
    width: 156.7,
    height: 323.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-10",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-516"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "178.8 226.4 182.5 228.3 190.4 316.1 164.9 294.3 178.8 226.4"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1443.26,
    y1: 2533.9,
    x2: 1430.51,
    y2: 2720.16,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1221.36,
    y1: 1576.9,
    x2: 1221.36,
    y2: 1590.73,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1025"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1026"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1478"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1479"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1480"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1481"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1482"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1483"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1484"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1485"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1486"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1487"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1497.4,
    y1: 2502.19,
    x2: 1490.81,
    y2: 2632.44,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 33.7,
    y: -7,
    width: 125.1,
    height: 320.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-11",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-485"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-372",
    points: "158.8 295.6 92.8 295.6 92.8 313.4 97.7 313.4 97.7 301.3 158.8 301.3 158.8 295.6"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1497.4,
    y1: 2502.19,
    x2: 1490.81,
    y2: 2632.44,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1497.4,
    y1: 2502.19,
    x2: 1490.81,
    y2: 2632.44,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1193.28,
    y1: 1574.24,
    x2: 1249.51,
    y2: 1574.24,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1221.36,
    y1: 1605.24,
    x2: 1221.36,
    y2: 1751.81,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1557.32,
    y1: 2762.84,
    x2: 1392.75,
    y2: 2746.25,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1489"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1490"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1942"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1943"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1944"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1945"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1946"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1947"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1948"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1949"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1950"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1951"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1465.63,
    y1: 2704.02,
    x2: 1972.26,
    y2: 2282.73,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 33.7,
    y: -7,
    width: 91.9,
    height: 302.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-12",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-502"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "m68.6,160.1c0,15.2.5,29.2,1.4,42.3,4.3,59.5,16.6,93.2,16.6,93.2h16C60,143.7,124.9,8.9,125.6,7.3c-.7.9-36.5,43.5-51.1,103.7-3.6,15.4-5.9,31.9-5.9,49.1Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1465.63,
    y1: 2704.02,
    x2: 1972.26,
    y2: 2282.73,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1953"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1954"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2406"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2407"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2408"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2409"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-313",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2410"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2411"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2412"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2413"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2414"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2415"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1499.93,
    y1: 2621.86,
    x2: 1355.8,
    y2: 2921.68,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 33.7,
    y: -7,
    width: 148.6,
    height: 302.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-13",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-557"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "m182.3,160.1c0,15.2-.5,29.2-1.4,42.3-4.3,59.5-16.6,93.2-16.6,93.2h-16C190.9,143.7,126.2,8.9,125.3,7.3c.7.9,36.5,43.5,51.2,103.8,3.5,15.3,5.8,31.8,5.8,49Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1499.93,
    y1: 2621.86,
    x2: 1355.8,
    y2: 2921.68,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1499.93,
    y1: 2621.86,
    x2: 1355.8,
    y2: 2921.68,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1219.56,
    y1: 1624.54,
    x2: 1219.56,
    y2: 1573.48,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1223.51,
    y1: 1571.26,
    x2: 1223.51,
    y2: 1610.54,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2417"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2418"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2870"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2871"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2872"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2873"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2874"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2875"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2876"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2877"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2878"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2879"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1513.31,
    y1: 2650.45,
    x2: 1382.31,
    y2: 2737.73,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 33.7,
    y: -7,
    width: 115.5,
    height: 191.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-14",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-536"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-385",
    cx: 124.2,
    cy: 159.5,
    r: 25
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1513.31,
    y1: 2650.45,
    x2: 1382.31,
    y2: 2737.73,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1513.31,
    y1: 2650.45,
    x2: 1382.31,
    y2: 2737.73,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1221.56,
    y1: 1754.48,
    x2: 1221.56,
    y2: 1717.9,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1229.45,
    y1: 1718.56,
    x2: 1217.67,
    y2: 1737,
    gradientTransform: "translate(1347.16 1889.34) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2881"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2882"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3334"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3335"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3336"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3337"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3338"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3339"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3340"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3341"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3342"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3343"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1511.21,
    y1: 2687.27,
    x2: 1422.58,
    y2: 2609.22,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 33.7,
    y: -7,
    width: 108.2,
    height: 174,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-15",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-517"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "m116.7,144.5l22.5,22.5c1.6-2.5,2.7-5.5,2.7-8.9,0-8.9-7.3-16.2-16.2-16.2-3.3,0-6.3.9-9,2.6Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1511.21,
    y1: 2687.27,
    x2: 1422.58,
    y2: 2609.22,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1511.21,
    y1: 2687.27,
    x2: 1422.58,
    y2: 2609.22,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3345"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3346"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3798"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3799"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3800"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3801"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3802"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3803"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3804"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3805"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3806"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "39 -1.7 40.8 -1.7 39 .1 39 -1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3807"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "35.4 -5.2 33.7 -5.2 35.4 -7 35.4 -5.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1496.95,
    y1: 2680.3,
    x2: 1504.14,
    y2: 2610.63,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 33.7,
    y: -7,
    width: 102.2,
    height: 180.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-16",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-500"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "m110.1,153.1l20.3,20.3c2-.7,3.9-1.6,5.5-3l-22.8-22.6c-1.2,1.6-2.2,3.3-3,5.3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1496.95,
    y1: 2680.3,
    x2: 1504.14,
    y2: 2610.63,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1496.95,
    y1: 2680.3,
    x2: 1504.14,
    y2: 2610.63,
    gradientTransform: "translate(1622.21 2820.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -117.39,
    y1: 886.3,
    x2: -117.39,
    y2: 944.51,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ef8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -148.77,
    y1: 995,
    x2: -148.77,
    y2: 941.27,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -85.67,
    y1: 995,
    x2: -85.67,
    y2: 941.27,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3809"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3810"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4262"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4263"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4264"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-326",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4265"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4266"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4267"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4268"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4269"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4270"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4271"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 199.41,
    y1: 1898.34,
    x2: 139.04,
    y2: 1915.23,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 1028.3,
    y: 767.3,
    width: 28.8,
    height: 176.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-17",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-514"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-435",
    points: "1028.3 931.8 1042.3 943.7 1038 895.8 1035.9 894.7 1028.3 931.8"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 199.41,
    y1: 1898.34,
    x2: 139.04,
    y2: 1915.23,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4273"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4274"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4726"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4727"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4728"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4729"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4730"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4731"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4732"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4733"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4734"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4735"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 128.73,
    y1: 1892.76,
    x2: 121.76,
    y2: 1994.43,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 971.5,
    y: 767.3,
    width: 85.6,
    height: 176.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-18",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-553"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-448",
    points: "985.4 931.8 971.5 943.7 975.8 895.8 977.8 894.7 985.4 931.8"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 128.73,
    y1: 1892.76,
    x2: 121.76,
    y2: 1994.43,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -117.37,
    y1: 947.65,
    x2: -117.37,
    y2: 955.2,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4737"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4738"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5190"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5191"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5192"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5193"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5194"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5195"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5196"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5197"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5198"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5199"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 158.23,
    y1: 1875.45,
    x2: 154.63,
    y2: 1946.55,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 988.7,
    y: 767.3,
    width: 68.4,
    height: 174.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-19",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-498"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-356",
    points: "988.7 935.6 1022.1 935.6 1022.1 942.2 1024.7 942.2 1024.7 932.5 988.7 932.5 988.7 935.6"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 158.23,
    y1: 1875.45,
    x2: 154.63,
    y2: 1946.55,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 158.23,
    y1: 1875.45,
    x2: 154.63,
    y2: 1946.55,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -132.64,
    y1: 946.19,
    x2: -101.95,
    y2: 946.19,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -117.32,
    y1: 963.13,
    x2: -117.32,
    y2: 1043.13,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 190.99,
    y1: 2017.76,
    x2: 101.16,
    y2: 2008.71,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5201"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5202"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5654"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5655"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5656"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5657"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5658"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5659"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5660"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5661"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5662"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5663"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 140.97,
    y1: 1985.66,
    x2: 417.52,
    y2: 1755.68,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 1006.9,
    y: 767.3,
    width: 50.2,
    height: 165.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-20",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-493"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "m1034.8,831.7c-8-32.9-27.5-56.2-27.9-56.6.4.9,35.8,74.5,12.6,157.4h8.8s6.7-18.4,9.1-50.9c.5-7.1.8-14.8.8-23.1-.2-9.3-1.5-18.4-3.4-26.8Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 140.97,
    y1: 1985.66,
    x2: 417.52,
    y2: 1755.68,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5665"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5666"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-321",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6118"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6119"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6120"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6121"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6123"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6124"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6125"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6126"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6127"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 159.6,
    y1: 1940.74,
    x2: 80.92,
    y2: 2104.41,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 975.7,
    y: 767.3,
    width: 81.4,
    height: 165.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-21",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-515"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "m979.1,831.7c8-32.9,27.5-56.2,27.9-56.6-.5.9-35.8,74.5-12.6,157.4h-8.8s-6.7-18.4-9.1-50.9c-.5-7.1-.8-14.8-.8-23.1.2-9.3,1.5-18.4,3.4-26.8Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 159.6,
    y1: 1940.74,
    x2: 80.92,
    y2: 2104.41,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 159.6,
    y1: 1940.74,
    x2: 80.92,
    y2: 2104.41,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -118.32,
    y1: 973.66,
    x2: -118.32,
    y2: 945.79,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -116.17,
    y1: 944.58,
    x2: -116.17,
    y2: 966.02,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6129"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6130"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6582"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6583"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6584"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6585"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6586"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6587"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6588"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-307",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6589"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6590"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6591"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 166.96,
    y1: 1956.37,
    x2: 95.45,
    y2: 2004.01,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 994,
    y: 767.3,
    width: 63.1,
    height: 104.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-22",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-509"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-450",
    cx: 1007.6,
    cy: 858.2,
    r: 13.6
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 166.96,
    y1: 1956.37,
    x2: 95.45,
    y2: 2004.01,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 166.96,
    y1: 1956.37,
    x2: 95.45,
    y2: 2004.01,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -117.27,
    y1: 1044.59,
    x2: -117.27,
    y2: 1024.62,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -112.94,
    y1: 1024.96,
    x2: -119.37,
    y2: 1035.02,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6593"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6594"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7046"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7047"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7048"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7049"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7050"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7051"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7052"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7053"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7054"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7055"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-324",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 165.83,
    y1: 1976.47,
    x2: 117.45,
    y2: 1933.86,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 997.9,
    y: 767.3,
    width: 59.2,
    height: 95.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-23",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-510"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "m1006.8,848.6c-4.9,0-8.9,4-8.9,8.9,0,1.8.6,3.5,1.5,4.9l12.3-12.3c-1.5-1-3.1-1.5-4.9-1.5Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 165.83,
    y1: 1976.47,
    x2: 117.45,
    y2: 1933.86,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 165.83,
    y1: 1976.47,
    x2: 117.45,
    y2: 1933.86,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7057"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7058"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7510"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7511"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7512"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7513"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7514"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7515"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7516"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7517"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7518"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "1054.1 771.2 1053.2 770.2 1054.1 770.2 1054.1 771.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7519"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "1056.1 767.3 1057.1 768.3 1056.1 768.3 1056.1 767.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 157.9,
    y1: 1972.66,
    x2: 161.82,
    y2: 1934.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 1001.1,
    y: 767.3,
    width: 56,
    height: 98.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-24",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-533"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "m1013.6,851.8l-12.5,12.4c.9.8,1.9,1.3,3,1.7l11.1-11.1c-.3-1.2-.9-2.1-1.6-3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 157.9,
    y1: 1972.66,
    x2: 161.82,
    y2: 1934.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 157.9,
    y1: 1972.66,
    x2: 161.82,
    y2: 1934.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -49.66,
    y1: 691.51,
    x2: -49.66,
    y2: 798.14,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ef8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -107.37,
    y1: 890.64,
    x2: -107.37,
    y2: 792.2,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 8.33,
    y1: 890.64,
    x2: 8.33,
    y2: 792.2,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7521"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7522"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7974"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7975"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7976"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7977"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7978"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7979"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7980"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-327",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7981"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7982"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7983"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 301.7,
    y1: 1771.14,
    x2: 191.11,
    y2: 1802.08,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 1114,
    y: 766,
    width: 52.6,
    height: 323.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-25",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-527"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-411",
    points: "1114 1067.3 1139.5 1089.1 1131.6 1001.3 1127.9 999.4 1114 1067.3"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 301.7,
    y1: 1771.14,
    x2: 191.11,
    y2: 1802.08,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7985"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7986"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8438"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8439"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8440"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8441"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8442"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8443"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8444"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8445"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8446"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-325",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8447"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 172.29,
    y1: 1760.9,
    x2: 159.53,
    y2: 1947.16,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 1009.9,
    y: 766,
    width: 156.7,
    height: 323.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-26",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-483"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-452",
    points: "1035.3 1067.3 1009.9 1089.1 1017.7 1001.3 1021.4 999.4 1035.3 1067.3"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 172.29,
    y1: 1760.9,
    x2: 159.53,
    y2: 1947.16,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -49.67,
    y1: 803.9,
    x2: -49.67,
    y2: 817.73,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8449"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8450"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8902"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8903"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8904"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8905"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8906"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8907"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8908"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8909"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8910"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8911"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 226.37,
    y1: 1729.19,
    x2: 219.79,
    y2: 1859.44,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 1041.4,
    y: 766,
    width: 125.2,
    height: 320.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-27",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-508"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-414",
    points: "1041.4 1074.3 1102.6 1074.3 1102.6 1086.4 1107.4 1086.4 1107.4 1068.6 1041.4 1068.6 1041.4 1074.3"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 226.37,
    y1: 1729.19,
    x2: 219.79,
    y2: 1859.44,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 226.37,
    y1: 1729.19,
    x2: 219.79,
    y2: 1859.44,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -77.67,
    y1: 801.24,
    x2: -21.47,
    y2: 801.24,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -49.57,
    y1: 832.24,
    x2: -49.57,
    y2: 978.81,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 286.33,
    y1: 1989.78,
    x2: 121.76,
    y2: 1973.2,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8913"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8914"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9366"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9367"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9368"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9369"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9370"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9371"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9372"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9373"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9374"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9375"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 194.63,
    y1: 1931.02,
    x2: 701.26,
    y2: 1509.73,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 1074.5,
    y: 766,
    width: 92.1,
    height: 302.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-28",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-550"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "m1125.7,884c-14.6-60.3-50.5-102.9-51.2-103.8.7,1.6,65.6,136.4,23,288.3h16s12.3-33.7,16.6-93.2c.9-13,1.4-27.1,1.4-42.3.1-17.1-2.2-33.6-5.8-49Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 194.63,
    y1: 1931.02,
    x2: 701.26,
    y2: 1509.73,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9377"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9378"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9830"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9831"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9832"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9833"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9834"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9835"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9836"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9837"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9838"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9839"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 229.03,
    y1: 1848.9,
    x2: 84.9,
    y2: 2148.73,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    x: 1018,
    y: 766,
    width: 148.6,
    height: 302.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-29",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-487"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "m1023.8,884c14.6-60.3,50.5-102.9,51.2-103.8-.9,1.6-65.6,136.4-23,288.3h-16s-12.3-33.7-16.6-93.2c-.9-13-1.4-27.1-1.4-42.3-.1-17.1,2.2-33.6,5.8-49Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 229.03,
    y1: 1848.9,
    x2: 84.9,
    y2: 2148.73,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 229.03,
    y1: 1848.9,
    x2: 84.9,
    y2: 2148.73,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -51.42,
    y1: 851.54,
    x2: -51.42,
    y2: 800.48,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -47.52,
    y1: 798.26,
    x2: -47.52,
    y2: 837.54,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e110e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9841"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9842"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10294"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10295"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10296"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10297"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10298"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10299"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10300"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10301"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10302"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10303"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 242.31,
    y1: 1877.44,
    x2: 111.31,
    y2: 1964.72,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 1051,
    y: 766,
    width: 115.6,
    height: 191.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-30",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-505"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-454",
    cx: 1076,
    cy: 932.5,
    r: 25
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 242.31,
    y1: 1877.44,
    x2: 111.31,
    y2: 1964.72,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 242.31,
    y1: 1877.44,
    x2: 111.31,
    y2: 1964.72,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06090f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -49.47,
    y1: 981.48,
    x2: -49.47,
    y2: 944.9,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -41.57,
    y1: 945.55,
    x2: -53.35,
    y2: 963.99,
    gradientTransform: "translate(1124.07 1889.34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14161c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3a2317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10305"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10306"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10758"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10759"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10760"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10761"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10762"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10763"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10764"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10765"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10766"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10767"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 240.25,
    y1: 1914.23,
    x2: 151.62,
    y2: 1836.18,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 1058.4,
    y: 766,
    width: 108.2,
    height: 174,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-31",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-491"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "m1074.6,914.9c-8.9,0-16.2,7.3-16.2,16.2,0,3.4,1.1,6.4,2.7,8.9l22.5-22.5c-2.8-1.7-5.8-2.6-9-2.6Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 240.25,
    y1: 1914.23,
    x2: 151.62,
    y2: 1836.18,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 240.25,
    y1: 1914.23,
    x2: 151.62,
    y2: 1836.18,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10769"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10770"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11222"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11223"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11224"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11225"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11226"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-328",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11227"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11228"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11229"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11230"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "1161.2 773.1 1159.4 771.3 1161.2 771.3 1161.2 773.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11231"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "1164.8 766 1166.6 767.8 1164.8 767.8 1164.8 766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 225.93,
    y1: 1907.29,
    x2: 233.11,
    y2: 1837.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 1064.3,
    y: 766,
    width: 102.3,
    height: 180.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-32",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-522"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "m1087.1,920.8l-22.8,22.6c1.6,1.4,3.6,2.3,5.5,3l20.3-20.3c-.7-2-1.8-3.7-3-5.3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 225.93,
    y1: 1907.29,
    x2: 233.11,
    y2: 1837.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 225.93,
    y1: 1907.29,
    x2: 233.11,
    y2: 1837.63,
    gradientTransform: "translate(849.01 2820.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 615.66,
    y1: -1313.57,
    x2: 508.35,
    y2: -1090.33,
    gradientTransform: "translate(0 1376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1018.84,
    y1: -877.23,
    x2: 911.53,
    y2: -654,
    gradientTransform: "translate(-303.46 419.22) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 205.54,
    y1: -877.24,
    x2: 98.24,
    y2: -654.01,
    gradientTransform: "translate(0 1376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 615.64,
    y1: -460.04,
    x2: 508.34,
    y2: -236.81,
    gradientTransform: "translate(0 1376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m598.5,238.3v54.7c0,25.5-20.7,46.2-46.2,46.2H239.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m236.6,339.3c-25.5,0-46.2,20.7-46.2,46.2v58.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m1006.6,663.3v54.7c0,25.5-20.7,46.2-46.2,46.2h-313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m644.7,764.3c-25.5,0-46.2,20.7-46.2,46.2v58.1"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-159",
    x1: 255.2,
    y1: 531.3,
    x2: 952.1,
    y2: 531.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "m204.3,171.1s4.3,23.6-11,59.1c0,0-13.6-22.5-10.7-59.1h21.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "212.4 156.6 237.6 178.2 227.7 124.3 218.9 120 212.4 156.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-403",
    points: "174.4 156.6 149.2 178.2 159 124.3 167.9 120 174.4 156.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-503"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-542"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-358",
    points: "164.3 121.7 162.2 122.8 158 170.7 171.9 158.8 164.3 121.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "164.3 121.7 162.2 122.8 158 170.7 171.9 158.8 164.3 121.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-484"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-541"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-401",
    points: "222.4 121.7 224.4 122.8 228.7 170.7 214.8 158.8 222.4 121.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "222.4 121.7 224.4 122.8 228.7 170.7 214.8 158.8 222.4 121.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-424",
    points: "175.5 169.2 211.5 169.2 211.5 159.5 175.5 159.5 175.5 169.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-488"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-482"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "211.5 159.5 175.5 159.5 175.5 169.2 178.1 169.2 178.1 162.6 211.5 162.6 211.5 159.5"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-352",
    points: "211.5 159.5 175.5 159.5 175.5 169.2 178.1 169.2 178.1 162.6 211.5 162.6 211.5 159.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-331",
    points: "178.1 171.1 208.8 171.1 208.8 169.2 178.1 169.2 178.1 171.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "m165.5,58.7c8-32.9,27.5-56.2,27.9-56.6h0s19.9,23.5,27.9,56.6c2,8.4,3.3,17.3,3.3,26.8,0,8.3-.3,16-.8,23.1-2.3,32.5-9.1,50.9-9.1,50.9h-42.7s-6.7-18.4-9.1-50.9c-.5-7-.8-14.7-.8-23.1.1-9.3,1.4-18.4,3.4-26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "m165.6,58.7c8.9,2.7,18.2,4.2,27.9,4.2s19.1-1.5,27.9-4.2c-8.2-33.2-28-56.6-28-56.6,0,0-19.9,23.5-27.8,56.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-492"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "m162.2,85.5c0,8.3.3,16,.8,23.1,2.3,32.5,9.1,50.9,9.1,50.9h8.8C157.6,76.6,193,3,193.4,2.1c-.4.5-20,23.7-27.9,56.6-2,8.4-3.3,17.5-3.3,26.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "m162.2,85.5c0,8.3.3,16,.8,23.1,2.3,32.5,9.1,50.9,9.1,50.9h8.8C157.6,76.6,193,3,193.4,2.1c-.4.5-20,23.7-27.9,56.6-2,8.4-3.3,17.5-3.3,26.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-554"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-523"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "m224.3,85.5c0,8.3-.3,16-.8,23.1-2.3,32.5-9.1,50.9-9.1,50.9h-8.8C229,76.6,193.7,3,193.2,2.1c.4.5,20,23.7,27.9,56.6,2,8.4,3.2,17.5,3.2,26.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "m224.3,85.5c0,8.3-.3,16-.8,23.1-2.3,32.5-9.1,50.9-9.1,50.9h-8.8C229,76.6,193.7,3,193.2,2.1c.4.5,20,23.7,27.9,56.6,2,8.4,3.2,17.5,3.2,26.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-393",
    points: "193.4 118.2 193.4 185.7 195.5 165.8 193.4 118.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "193.4 118.2 193.4 185.7 191.2 165.8 193.4 118.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-529"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-507"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-378",
    cx: 192.6,
    cy: 85.2,
    r: 13.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-426",
    cx: 192.6,
    cy: 85.2,
    r: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-380",
    cx: 193.4,
    cy: 84.4,
    r: 12.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "m184.5,84.4c0,4.9,4,8.9,8.9,8.9,1,0,1.8-.2,2.7-.4,1.1-.4,2.1-.9,3-1.7.7-.6,1.3-1.3,1.8-1.9.9-1.4,1.5-3,1.5-4.9,0-4.9-4-8.9-8.9-8.9-1.8,0-3.4.5-4.9,1.5-.8.5-1.4,1.1-1.9,1.8-.7.9-1.3,1.8-1.7,3-.3.8-.5,1.7-.5,2.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-464"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-532"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "m188.5,77l12.3,12.3c.9-1.4,1.5-3,1.5-4.9,0-4.9-4-8.9-8.9-8.9-1.8.1-3.4.6-4.9,1.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "m188.5,77l12.3,12.3c.9-1.4,1.5-3,1.5-4.9,0-4.9-4-8.9-8.9-8.9-1.8.1-3.4.6-4.9,1.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-561"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-548"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "m184.9,81.7l11.1,11.1c1.1-.4,2.1-.9,3-1.7l-12.5-12.4c-.6,1-1.2,1.9-1.6,3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "m184.9,81.7l11.1,11.1c1.1-.4,2.1-.9,3-1.7l-12.5-12.4c-.6,1-1.2,1.9-1.6,3Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "m145.6,316.8s7.8,43.1-20.1,108.2c0,0-25-41.2-19.6-108.2h39.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-366",
    points: "160.4 290.2 206.6 329.8 188.6 231.2 172.4 223.2 160.4 290.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-389",
    points: "90.9 290.2 44.7 329.8 62.7 231.2 78.9 223.2 90.9 290.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-489"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-519"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-457",
    points: "72.3 226.4 68.6 228.3 60.8 316.1 86.2 294.3 72.3 226.4"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "72.3 226.4 68.6 228.3 60.8 316.1 86.2 294.3 72.3 226.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-521"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-499"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-402",
    points: "178.8 226.4 182.5 228.3 190.4 316.1 164.9 294.3 178.8 226.4"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "178.8 226.4 182.5 228.3 190.4 316.1 164.9 294.3 178.8 226.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-374",
    points: "92.8 313.4 158.8 313.4 158.8 295.6 92.8 295.6 92.8 313.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-520"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-470"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-348",
    points: "158.8 295.6 92.8 295.6 92.8 313.4 97.7 313.4 97.7 301.3 158.8 301.3 158.8 295.6"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-382",
    points: "158.8 295.6 92.8 295.6 92.8 313.4 97.7 313.4 97.7 301.3 158.8 301.3 158.8 295.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-432",
    points: "97.7 316.8 153.8 316.8 153.8 313.4 97.7 313.4 97.7 316.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "m74.5,111C89.1,50.8,124.9,8.2,125.6,7.3h0s36.4,43,51.2,103.8c3.7,15.3,6.1,31.7,6.1,49,0,15.2-.5,29.2-1.4,42.3-4.3,59.5-16.6,93.2-16.6,93.2h-78.2s-12.3-33.7-16.6-93.2c-.9-12.8-1.4-26.9-1.4-42.3-.1-17.2,2.2-33.7,5.8-49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "m74.7,111c16.2,5,33.3,7.7,51.2,7.7s34.9-2.7,51.2-7.7C162,50.2,125.6,7.3,125.6,7.3c0,0-36.3,42.9-50.9,103.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-558"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "m68.6,160.1c0,15.2.5,29.2,1.4,42.3,4.3,59.5,16.6,93.2,16.6,93.2h16C60,143.7,124.9,8.9,125.6,7.3c-.7.9-36.5,43.5-51.1,103.7-3.6,15.4-5.9,31.9-5.9,49.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "m68.6,160.1c0,15.2.5,29.2,1.4,42.3,4.3,59.5,16.6,93.2,16.6,93.2h16C60,143.7,124.9,8.9,125.6,7.3c-.7.9-36.5,43.5-51.1,103.7-3.6,15.4-5.9,31.9-5.9,49.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-476"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-504"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "m182.3,160.1c0,15.2-.5,29.2-1.4,42.3-4.3,59.5-16.6,93.2-16.6,93.2h-16C190.9,143.7,126.2,8.9,125.3,7.3c.7.9,36.5,43.5,51.2,103.8,3.5,15.3,5.8,31.8,5.8,49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "m182.3,160.1c0,15.2-.5,29.2-1.4,42.3-4.3,59.5-16.6,93.2-16.6,93.2h-16C190.9,143.7,126.2,8.9,125.3,7.3c.7.9,36.5,43.5,51.2,103.8,3.5,15.3,5.8,31.8,5.8,49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-396",
    points: "125.6 220 125.6 343.5 129.6 307.1 125.6 220"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-415",
    points: "125.6 220 125.6 343.5 121.7 307.1 125.6 220"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-563"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-386",
    cx: 124.2,
    cy: 159.5,
    r: 25
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-443",
    cx: 124.2,
    cy: 159.5,
    r: 25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-341",
    cx: 125.6,
    cy: 158.1,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "m109.4,158.1c0,8.9,7.3,16.2,16.2,16.2,1.8,0,3.4-.4,5-.7,2-.7,3.9-1.6,5.5-3,1.2-1.1,2.3-2.3,3.2-3.6,1.6-2.5,2.7-5.5,2.7-8.9,0-8.9-7.3-16.2-16.2-16.2-3.2,0-6.2.9-8.9,2.7-1.4.9-2.5,2-3.6,3.2-1.2,1.6-2.3,3.4-3,5.5-.5,1.4-.9,3-.9,4.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-497"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-555"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "m116.7,144.5l22.5,22.5c1.6-2.5,2.7-5.5,2.7-8.9,0-8.9-7.3-16.2-16.2-16.2-3.3,0-6.3.9-9,2.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "m116.7,144.5l22.5,22.5c1.6-2.5,2.7-5.5,2.7-8.9,0-8.9-7.3-16.2-16.2-16.2-3.3,0-6.3.9-9,2.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-547"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-528"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "m110.1,153.1l20.3,20.3c2-.7,3.9-1.6,5.5-3l-22.8-22.6c-1.2,1.6-2.2,3.3-3,5.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "m110.1,153.1l20.3,20.3c2-.7,3.9-1.6,5.5-3l-22.8-22.6c-1.2,1.6-2.2,3.3-3,5.3Z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "m1017.6,944.1c2.9,36.6-10.7,59.1-10.7,59.1-15.3-35.5-11-59.1-11-59.1h21.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-375",
    points: "981.3 893 972.5 897.3 962.7 951.2 987.9 929.6 981.3 893"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-340",
    points: "1032.3 893 1041.2 897.3 1051 951.2 1025.8 929.6 1032.3 893"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-494"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-534"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-406",
    points: "1028.3 931.8 1042.3 943.7 1038 895.8 1035.9 894.7 1028.3 931.8"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "1028.3 931.8 1042.3 943.7 1038 895.8 1035.9 894.7 1028.3 931.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-479"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-363",
    points: "985.4 931.8 971.5 943.7 975.8 895.8 977.8 894.7 985.4 931.8"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "985.4 931.8 971.5 943.7 975.8 895.8 977.8 894.7 985.4 931.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-436",
    points: "1024.7 932.5 988.7 932.5 988.7 942.2 1024.7 942.2 1024.7 932.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-530"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-537"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "988.7 935.6 1022.1 935.6 1022.1 942.2 1024.7 942.2 1024.7 932.5 988.7 932.5 988.7 935.6"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-463",
    points: "988.7 935.6 1022.1 935.6 1022.1 942.2 1024.7 942.2 1024.7 932.5 988.7 932.5 988.7 935.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-346",
    points: "1022.1 942.2 991.5 942.2 991.5 944.1 1022.1 944.1 1022.1 942.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "m1038,858.5c0,8.4-.3,16.1-.8,23.1-2.3,32.5-9.1,50.9-9.1,50.9h-42.7s-6.7-18.4-9.1-50.9c-.5-7.1-.8-14.8-.8-23.1,0-9.4,1.3-18.4,3.3-26.8,8.1-33.2,27.9-56.6,27.9-56.6h0c.4.5,20,23.7,27.9,56.6,2.1,8.4,3.4,17.5,3.4,26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "m1006.8,775.1s-19.9,23.5-28,56.6c8.9,2.7,18.2,4.2,27.9,4.2s19.1-1.5,27.9-4.2c-7.9-33.1-27.8-56.6-27.8-56.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-538"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-526"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "m1034.8,831.7c-8-32.9-27.5-56.2-27.9-56.6.4.9,35.8,74.5,12.6,157.4h8.8s6.7-18.4,9.1-50.9c.5-7.1.8-14.8.8-23.1-.2-9.3-1.5-18.4-3.4-26.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "m1034.8,831.7c-8-32.9-27.5-56.2-27.9-56.6.4.9,35.8,74.5,12.6,157.4h8.8s6.7-18.4,9.1-50.9c.5-7.1.8-14.8.8-23.1-.2-9.3-1.5-18.4-3.4-26.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-480"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-513"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "m979.1,831.7c8-32.9,27.5-56.2,27.9-56.6-.5.9-35.8,74.5-12.6,157.4h-8.8s-6.7-18.4-9.1-50.9c-.5-7.1-.8-14.8-.8-23.1.2-9.3,1.5-18.4,3.4-26.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "m979.1,831.7c8-32.9,27.5-56.2,27.9-56.6-.5.9-35.8,74.5-12.6,157.4h-8.8s-6.7-18.4-9.1-50.9c-.5-7.1-.8-14.8-.8-23.1.2-9.3,1.5-18.4,3.4-26.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-433",
    points: "1004.7 938.8 1006.8 958.7 1006.8 891.2 1004.7 938.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-418",
    points: "1009 938.8 1006.8 958.7 1006.8 891.2 1009 938.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-539"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-556"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-447",
    cx: 1007.6,
    cy: 858.2,
    r: 13.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-334",
    cx: 1007.6,
    cy: 858.2,
    r: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-373",
    cx: 1006.8,
    cy: 857.4,
    r: 12.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "m1015.2,854.8c-.4-1.2-1-2.1-1.7-3-.6-.7-1.2-1.3-1.9-1.8-1.5-1-3.1-1.5-4.9-1.5-4.9,0-8.9,4-8.9,8.9,0,1.8.6,3.5,1.5,4.9.5.7,1.1,1.4,1.8,1.9.9.8,1.9,1.3,3,1.7.9.2,1.8.4,2.7.4,4.9,0,8.9-4,8.9-8.9,0-.9-.2-1.8-.5-2.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-546"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-543"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "m1006.8,848.6c-4.9,0-8.9,4-8.9,8.9,0,1.8.6,3.5,1.5,4.9l12.3-12.3c-1.5-1-3.1-1.5-4.9-1.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "m1006.8,848.6c-4.9,0-8.9,4-8.9,8.9,0,1.8.6,3.5,1.5,4.9l12.3-12.3c-1.5-1-3.1-1.5-4.9-1.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-564"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-468"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "m1013.6,851.8l-12.5,12.4c.9.8,1.9,1.3,3,1.7l11.1-11.1c-.3-1.2-.9-2.1-1.6-3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "m1013.6,851.8l-12.5,12.4c.9.8,1.9,1.3,3,1.7l11.1-11.1c-.3-1.2-.9-2.1-1.6-3Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "m1094.4,1089.8c5.3,67-19.6,108.2-19.6,108.2-28-65.1-20.1-108.2-20.1-108.2h39.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "1027.9 996.2 1011.6 1004.2 993.6 1102.8 1039.8 1063.2 1027.9 996.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "1121.3 996.2 1137.5 1004.2 1155.5 1102.8 1109.3 1063.2 1121.3 996.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-552"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-524"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-354",
    points: "1114 1067.3 1139.5 1089.1 1131.6 1001.3 1127.9 999.4 1114 1067.3"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "1114 1067.3 1139.5 1089.1 1131.6 1001.3 1127.9 999.4 1114 1067.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-540"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-518"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-362",
    points: "1035.3 1067.3 1009.9 1089.1 1017.7 1001.3 1021.4 999.4 1035.3 1067.3"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "1035.3 1067.3 1009.9 1089.1 1017.7 1001.3 1021.4 999.4 1035.3 1067.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-349",
    points: "1107.4 1068.6 1041.4 1068.6 1041.4 1086.4 1107.4 1086.4 1107.4 1068.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-535"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-471"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-353",
    points: "1041.4 1074.3 1102.6 1074.3 1102.6 1086.4 1107.4 1086.4 1107.4 1068.6 1041.4 1068.6 1041.4 1074.3"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-439",
    points: "1041.4 1074.3 1102.6 1074.3 1102.6 1086.4 1107.4 1086.4 1107.4 1068.6 1041.4 1068.6 1041.4 1074.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-462",
    points: "1102.6 1086.4 1046.4 1086.4 1046.4 1089.8 1102.6 1089.8 1102.6 1086.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "m1131.6,933.1c0,15.3-.5,29.4-1.4,42.3-4.3,59.5-16.6,93.2-16.6,93.2h-78.2s-12.3-33.7-16.6-93.2c-.9-13-1.4-27.1-1.4-42.3,0-17.3,2.3-33.7,6.1-49,14.8-60.8,51.2-103.8,51.2-103.8h0c.7.9,36.5,43.5,51.2,103.8,3.4,15.3,5.7,31.8,5.7,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "m1074.6,780.3s-36.4,43-51.3,103.8c16.2,5,33.3,7.7,51.2,7.7s34.9-2.7,51.2-7.7c-14.8-60.9-51.1-103.8-51.1-103.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-531"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-469"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "m1125.7,884c-14.6-60.3-50.5-102.9-51.2-103.8.7,1.6,65.6,136.4,23,288.3h16s12.3-33.7,16.6-93.2c.9-13,1.4-27.1,1.4-42.3.1-17.1-2.2-33.6-5.8-49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "m1125.7,884c-14.6-60.3-50.5-102.9-51.2-103.8.7,1.6,65.6,136.4,23,288.3h16s12.3-33.7,16.6-93.2c.9-13,1.4-27.1,1.4-42.3.1-17.1-2.2-33.6-5.8-49Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-511"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-559"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "m1023.8,884c14.6-60.3,50.5-102.9,51.2-103.8-.9,1.6-65.6,136.4-23,288.3h-16s-12.3-33.7-16.6-93.2c-.9-13-1.4-27.1-1.4-42.3-.1-17.1,2.2-33.6,5.8-49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "m1023.8,884c14.6-60.3,50.5-102.9,51.2-103.8-.9,1.6-65.6,136.4-23,288.3h-16s-12.3-33.7-16.6-93.2c-.9-13-1.4-27.1-1.4-42.3-.1-17.1,2.2-33.6,5.8-49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-459",
    points: "1070.7 1080.1 1074.6 1116.5 1074.6 993 1070.7 1080.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "1078.5 1080.1 1074.6 1116.5 1074.6 993 1078.5 1080.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-506"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-545"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-405",
    cx: 1076,
    cy: 932.5,
    r: 25
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-371",
    cx: 1076,
    cy: 932.5,
    r: 25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-431",
    cx: 1074.6,
    cy: 931.1,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "m1089.9,926.3c-.7-2.1-1.8-3.9-3-5.5-1.1-1.2-2.1-2.3-3.6-3.2-2.7-1.8-5.7-2.7-8.9-2.7-8.9,0-16.2,7.3-16.2,16.2,0,3.4,1.1,6.4,2.7,8.9.9,1.2,2,2.5,3.2,3.6,1.6,1.4,3.6,2.3,5.5,3,1.6.4,3.2.7,5,.7,8.9,0,16.2-7.3,16.2-16.2,0-1.8-.4-3.4-.9-4.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-501"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-496"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "m1074.6,914.9c-8.9,0-16.2,7.3-16.2,16.2,0,3.4,1.1,6.4,2.7,8.9l22.5-22.5c-2.8-1.7-5.8-2.6-9-2.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "m1074.6,914.9c-8.9,0-16.2,7.3-16.2,16.2,0,3.4,1.1,6.4,2.7,8.9l22.5-22.5c-2.8-1.7-5.8-2.6-9-2.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-478"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-495"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "m1087.1,920.8l-22.8,22.6c1.6,1.4,3.6,2.3,5.5,3l20.3-20.3c-.7-2-1.8-3.7-3-5.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "m1087.1,920.8l-22.8,22.6c1.6,1.4,3.6,2.3,5.5,3l20.3-20.3c-.7-2-1.8-3.7-3-5.3Z"
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-410",
    cx: 600,
    cy: 95,
    r: 93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-446",
    cx: 600,
    cy: 95.5,
    r: 93
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 600,
    cy: 95.5,
    r: 76
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-343",
    cx: 1003.2,
    cy: 531.3,
    r: 93,
    transform: "translate(-81.86 864.98) rotate(-45)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-446",
    cx: 1003.2,
    cy: 531.3,
    r: 93,
    transform: "translate(-81.86 864.98) rotate(-45)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1003.2,
    cy: 531.3,
    r: 76,
    transform: "translate(-81.86 864.98) rotate(-45)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-342",
    cx: 189.9,
    cy: 531.3,
    r: 93
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-446",
    cx: 189.9,
    cy: 531.3,
    r: 93
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.9,
    cy: 531.3,
    r: 76
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-133",
    cx: 600,
    cy: 75.5,
    rx: 27,
    ry: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m627,90c0,6.6-12.1,12-27,12s-27-5.4-27-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m627,104.5c0,6.6-12.1,12-27,12s-27-5.4-27-12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m627,119c0,6.6-12.1,12-27,12s-27-5.4-27-12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 449,
    y: 188,
    width: 299,
    height: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 40.9,
    y: 624,
    width: 299,
    height: 60
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 857.2,
    y: 624,
    width: 299,
    height: 60
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-474",
    transform: "translate(546 229.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-549",
    x: 21.73,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.21,
    y: 0
  }, "AKE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-473",
    transform: "translate(50.39 663.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "APP"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-525",
    x: 64.91,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-562",
    x: 81.3,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.78,
    y: 0,
    xmlSpace: "preserve"
  }, " WHITELIST"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-474",
    transform: "translate(969.17 664.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-475",
    x: 47.06,
    y: 0
  }, "Y"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "207.9 501 219.9 501 219.9 566.7 159.5 566.7 159.5 501 174.1 501 174.1 498 204.9 498 204.9 501 207.9 501"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-252",
    points: "173.9 501 173.9 516 184.9 516"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-252",
    points: "205.3 502 205.3 516 192.9 516"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "m181.9,516.5c0-3.9,3.1-7,7-7s7,3.1,7,7"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-252",
    points: "178.9 541 186.9 548 199.4 535.5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-420",
    cx: 600,
    cy: 948.5,
    r: 93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-446",
    cx: 599.99,
    cy: 948.5,
    r: 93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-236",
    cx: 599.99,
    cy: 948.5,
    r: 76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 449,
    y: 1041.2,
    width: 299,
    height: 60
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "m561.4,1080.1c-.4.6-1,1.1-1.6,1.4-.7.3-1.4.5-2.1.5-.9,0-1.8-.3-2.5-.7-.8-.5-1.3-1.1-1.7-1.9s-.6-1.8-.6-2.9v-7.1c0-1.1.2-2.1.6-2.9.4-.8,1-1.5,1.7-1.9.7-.5,1.5-.7,2.5-.7.7,0,1.4.2,2,.5s1.1.8,1.6,1.4c.5.7.8,1.4,1,2.2h4.4c-.3-1.7-.9-3.2-1.7-4.4-.8-1.3-1.8-2.2-3.1-2.9-1.3-.7-2.7-1-4.2-1-1.9,0-3.5.4-4.9,1.2-1.4.7-2.5,1.9-3.2,3.3s-1.1,3.1-1.1,5.1v7.1c0,2,.4,3.7,1.1,5.1.8,1.4,1.8,2.5,3.2,3.3,1.3.8,3,1.2,5,1.4,1.5,0,2.9-.3,4.2-1,1.2-.7,2.3-1.7,3.1-2.9.8-1.2,1.4-2.7,1.7-4.4h-4.4c-.2.8-.5,1.6-1,2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "575.7 1060 571.5 1060 571.5 1085.8 573.4 1085.8 575.7 1085.8 588.3 1085.8 588.3 1081.7 575.7 1081.7 575.7 1060"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "m599.4,1060l-9.8,25.8h4.6l1.7-4.9h10l1.7,4.9h4.6l-9.7-25.8h-3.1Zm-2.1,16.8l3.6-10.2,3.6,10.2h-7.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-387",
    x: 615.6,
    y: 1059.9,
    width: 4.3,
    height: 25.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "643.1 1060 636.9 1077.2 630.7 1060 625.8 1060 625.8 1085.8 629.8 1085.8 629.8 1068.2 635.2 1082.6 638.6 1082.6 644 1067.8 644 1085.8 648 1085.8 648 1060 643.1 1060"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m630.7,929.5l-11.4-10.3h-38l-10.8,10.6c-.2.2,0,.4.2.4h59.8c.2,0,.4-.4.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m570.4,929.2v44c0,3.3,2.7,6,6,6h48.4c3.3,0,6-2.7,6-6v-44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-133",
    x1: 599.9,
    y1: 939.8,
    x2: 599.9,
    y2: 966.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-178",
    points: "586.8 954.2 600 968 613.6 954.4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m1021.1,566.9h-43.8c-3.1,0-5.4-2.7-5.1-5.7l5.1-40.1c.3-2.3,2.3-4.1,4.6-4.1h42.3c1.4,0,2.6,1.1,2.7,2.5l1.8,17.7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-202",
    cx: 1021.4,
    cy: 551.5,
    r: 15.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m990.3,526.4v-14.7c0-6.8,5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3v14.7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-159",
    x1: 1020.9,
    y1: 544.9,
    x2: 1020.9,
    y2: 557.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-159",
    x1: 1027,
    y1: 551.1,
    x2: 1014.8,
    y2: 551.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction);
export default __webpack_public_path__ + "static/media/instruction.31bbc4096550c52d95f81f7cf6c5735c.svg";
export { ForwardRef as ReactComponent };